import { useState, useEffect } from 'react'
import { 
  Users, 
  Package, 
  MessageSquare, 
  DollarSign,
  Plus,
  Edit3,
  Trash2,
  ToggleLeft,
  ToggleRight,
  Upload,
  Send,
  RefreshCw,
  Star,
  Eye,
  CornerUpLeft,
  Shield,
  UserPlus,
  Key,
  Settings,
  Activity,
  Globe
} from 'lucide-react'
import axios from 'axios'
import toast from 'react-hot-toast'
import GlobalAdminWebsites from './GlobalAdminWebsites'
import { LoadingButton, IconButton } from '../../components/LoadingButton'

export default function GlobalAdminDashboard() {
  const [activeTab, setActiveTab] = useState('dashboard')
  const [stats, setStats] = useState({})
  const [users, setUsers] = useState([])
  const [tickets, setTickets] = useState([])
  const [selectedTicket, setSelectedTicket] = useState(null)
  const [advertisements, setAdvertisements] = useState([])
  const [globalAdmins, setGlobalAdmins] = useState([])
  const [escrowTickets, setEscrowTickets] = useState([])
  const [selectedEscrowTicket, setSelectedEscrowTicket] = useState(null)
  const [actionLogs, setActionLogs] = useState([])
  const [actionLogsPagination, setActionLogsPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0
  })
  const [usersPagination, setUsersPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    pageSize: 20
  })
  const [premiumUsersPagination, setPremiumUsersPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    pageSize: 20
  })
  const [premiumRequestsPagination, setPremiumRequestsPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    pageSize: 20
  })
  const [advertisementsPagination, setAdvertisementsPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    pageSize: 20
  })
  const [adsensePagesPagination, setAdSensePagesPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    pageSize: 20
  })
  const [globalAdminsPagination, setGlobalAdminsPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    pageSize: 20
  })
  const [currentAdmin, setCurrentAdmin] = useState(null)
  const [loading, setLoading] = useState(true)
  const [adsenseConfig, setAdSenseConfig] = useState(null)
  const [adsensePages, setAdSensePages] = useState([])
  const [adsenseLoading, setAdSenseLoading] = useState(false)
  const [showAdForm, setShowAdForm] = useState(false)
  const [showMessageModal, setShowMessageModal] = useState(false)
  const [showBroadcastModal, setShowBroadcastModal] = useState(false)
  const [broadcastLoading, setBroadcastLoading] = useState(false)
  const [showCreateAdminModal, setShowCreateAdminModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [adFormData, setAdFormData] = useState({
    name: '',
    description: '',
    duration: 'week',
    mediaUrl: ''
  })
  const [messageData, setMessageData] = useState({
    subject: '',
    message: ''
  })
  const [broadcastData, setBroadcastData] = useState({
    subject: '',
    message: ''
  })
  const [newAdminData, setNewAdminData] = useState({
    email: '',
    password: ''
  })
  const [replyMessage, setReplyMessage] = useState('')
  const [escrowReplyMessage, setEscrowReplyMessage] = useState('')
  const [adFile, setAdFile] = useState(null)
  // Premium management state
  const [premiumUsers, setPremiumUsers] = useState([])
  const [appPremiumMode, setAppPremiumMode] = useState(true)
  const [premiumStats, setPremiumStats] = useState({
    totalUsers: 0,
    premiumUsers: 0,
    freeUsers: 0
  })
  const [extraPremiumRequests, setExtraPremiumRequests] = useState([])
  const [premiumRequestSelections, setPremiumRequestSelections] = useState({})
  const [processingPremiumRequestId, setProcessingPremiumRequestId] = useState(null)
  const [clearingAllRequests, setClearingAllRequests] = useState(false)
  const [deletingRequestId, setDeletingRequestId] = useState(null)
  const [refreshingPremiumRequests, setRefreshingPremiumRequests] = useState(false)
  const [togglingStatusUserId, setTogglingStatusUserId] = useState(null)
  const [togglingRecommendationUserId, setTogglingRecommendationUserId] = useState(null)
  const [deletingUserId, setDeletingUserId] = useState(null)
  const [recoveringUserId, setRecoveringUserId] = useState(null)
  const [resettingPasswordUserId, setResettingPasswordUserId] = useState(null)
  const [replyLoading, setReplyLoading] = useState(false)
  const [escrowReplyLoading, setEscrowReplyLoading] = useState(false)
  const [sendMessageLoading, setSendMessageLoading] = useState(false)
  const [createAdminLoading, setCreateAdminLoading] = useState(false)
  const [adsensePageLoading, setAdSensePageLoading] = useState({})
  const [adsenseConfigLoading, setAdSenseConfigLoading] = useState(false)
  const [adsenseValidationErrors, setAdSenseValidationErrors] = useState({})
  const [adsenseSaveAttempted, setAdSenseSaveAttempted] = useState(false)
  const [refreshingUsers, setRefreshingUsers] = useState(false)
  const [refreshingTickets, setRefreshingTickets] = useState(false)
  const [refreshingEscrowTickets, setRefreshingEscrowTickets] = useState(false)
  const [loadingActionLogs, setLoadingActionLogs] = useState(false)
  const [deletingTicketId, setDeletingTicketId] = useState(null)
  const [deletingEscrowTicketId, setDeletingEscrowTicketId] = useState(null)
  const [deletingAdId, setDeletingAdId] = useState(null)
  const [creatingAd, setCreatingAd] = useState(false)

  // Search and filter state
  const [usersSearch, setUsersSearch] = useState('')
  const [usersStatusFilter, setUsersStatusFilter] = useState('all')
  const [usersSortBy, setUsersSortBy] = useState('createdAt')
  const [usersSortOrder, setUsersSortOrder] = useState('desc')
  const [advertisementsSearch, setAdvertisementsSearch] = useState('')
  const [advertisementsSortBy, setAdvertisementsSortBy] = useState('createdAt')
  const [advertisementsSortOrder, setAdvertisementsSortOrder] = useState('desc')
  const [globalAdminsSearch, setGlobalAdminsSearch] = useState('')
  const [globalAdminsSortBy, setGlobalAdminsSortBy] = useState('createdAt')
  const [globalAdminsSortOrder, setGlobalAdminsSortOrder] = useState('desc')
  const [premiumUsersSearch, setPremiumUsersSearch] = useState('')
  const [premiumUsersSortBy, setPremiumUsersSortBy] = useState('createdAt')
  const [premiumUsersSortOrder, setPremiumUsersSortOrder] = useState('desc')
  const [extraPremiumRequestsSearch, setExtraPremiumRequestsSearch] = useState('')
  const [extraPremiumRequestsSortBy, setExtraPremiumRequestsSortBy] = useState('requestedAt')
  const [extraPremiumRequestsSortOrder, setExtraPremiumRequestsSortOrder] = useState('desc')
  const [actionLogsActionType, setActionLogsActionType] = useState('all')
  const [actionLogsSortBy, setActionLogsSortBy] = useState('timestamp')
  const [actionLogsSortOrder, setActionLogsSortOrder] = useState('desc')
  
  // Button loading states
  const [upgradingUserId, setUpgradingUserId] = useState(null)
  const [downgradingUserId, setDowngradingUserId] = useState(null)
  const [deletingAdminId, setDeletingAdminId] = useState(null)
  const [toggleAppPremiumModeLoading, setToggleAppPremiumModeLoading] = useState(false)
  const [applyingExtraPremiumSort, setApplyingExtraPremiumSort] = useState(false)

  // AdSense validation functions
  const validatePublisherId = (publisherId) => {
    if (!publisherId || typeof publisherId !== 'string') return false
    const trimmed = publisherId.trim()
    return /^pub-\d{16}$/.test(trimmed)
  }

  const validateAdClientId = (adClientId) => {
    if (!adClientId || typeof adClientId !== 'string') return false
    const trimmed = adClientId.trim()
    return /^ca-pub-\d{16}$/.test(trimmed)
  }

  const validateAdSenseConfig = () => {
    const errors = {}

    if (adsenseConfig?.publisherId && !validatePublisherId(adsenseConfig.publisherId)) {
      errors.publisherId = 'Publisher ID must be in format: pub-xxxxxxxxxxxxxxxx (pub- followed by 16 digits)'
    }

    if (adsenseConfig?.adClientId && !validateAdClientId(adsenseConfig.adClientId)) {
      errors.adClientId = 'Ad Client ID must be in format: ca-pub-xxxxxxxxxxxxxxxx (ca-pub- followed by 16 digits)'
    }

    if (adsenseConfig?.adScript && typeof adsenseConfig.adScript !== 'string') {
      errors.adScript = 'AdSense script must be a valid string'
    }

    setAdSenseValidationErrors(errors)
    return Object.keys(errors).length === 0
  }

  useEffect(() => {
    fetchCurrentAdmin()
    fetchDashboardData()
  }, [])

  useEffect(() => {
    if (activeTab === 'users') {
      fetchUsers(usersPagination.currentPage, usersPagination.pageSize)
    } else if (activeTab === 'advertisements') {
      fetchAdvertisements(advertisementsPagination.currentPage, advertisementsPagination.pageSize)
    } else if (activeTab === 'adsense') {
      fetchAdSenseConfig(adsensePagesPagination.currentPage, adsensePagesPagination.pageSize)
    } else if (activeTab === 'tickets') {
      fetchTickets()
    } else if (activeTab === 'admins') {
      fetchGlobalAdmins(globalAdminsPagination.currentPage, globalAdminsPagination.pageSize)
    } else if (activeTab === 'escrow') {
      fetchEscrowTickets()
    } else if (activeTab === 'action-logs') {
      fetchActionLogs()
    } else if (activeTab === 'premium') {
      fetchPremiumData(premiumUsersPagination.currentPage, premiumUsersPagination.pageSize)
      fetchExtraPremiumRequests(premiumRequestsPagination.currentPage, premiumRequestsPagination.pageSize)
    }
  }, [activeTab])

  const fetchCurrentAdmin = async () => {
    try {
      const response = await axios.get('/global-admin/profile')
      setCurrentAdmin(response.data.admin)
      console.log('Current admin loaded:', response.data.admin)
    } catch (error) {
      console.error('Error fetching current admin:', error)
    }
  }

  const fetchDashboardData = async () => {
    try {
      const response = await axios.get('/global-admin/dashboard')
      setStats(response.data.stats)
    } catch (error) {
      toast.error('Error loading dashboard data')
    } finally {
      setLoading(false)
    }
  }

  const fetchUsers = async (page = 1, pageSize = 20) => {
    setRefreshingUsers(true)
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: pageSize.toString(),
        sortBy: usersSortBy,
        sortOrder: usersSortOrder
      })

      if (usersSearch) params.append('search', usersSearch)
      if (usersStatusFilter !== 'all') params.append('status', usersStatusFilter)

      const response = await axios.get(`/global-admin/users?${params}`)
      // Filter out null or undefined users
      const validUsers = (response.data.users || []).filter(user => user != null)
      setUsers(validUsers)
      setUsersPagination({
        currentPage: response.data.currentPage || page,
        totalPages: response.data.totalPages || 1,
        total: response.data.total || 0,
        pageSize: pageSize
      })
    } catch (error) {
      toast.error('Error loading users')
      // Set empty state on error
      setUsers([])
      setUsersPagination({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        pageSize: pageSize
      })
    } finally {
      setRefreshingUsers(false)
    }
  }

  const fetchTickets = async () => {
    setRefreshingTickets(true)
    try {
      const response = await axios.get('/global-admin/tickets')
      setTickets(response.data.tickets || [])
    } catch (error) {
      toast.error('Error loading tickets')
    } finally {
      setRefreshingTickets(false)
    }
  }

  const fetchTicketDetails = async (ticketId) => {
    try {
      const response = await axios.get(`/global-admin/tickets/${ticketId}`)
      setSelectedTicket(response.data)
    } catch (error) {
      toast.error('Error loading ticket details')
    }
  }

  const fetchAdvertisements = async (page = 1, pageSize = advertisementsPagination.pageSize) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: pageSize.toString(),
        sortBy: advertisementsSortBy,
        sortOrder: advertisementsSortOrder
      })

      if (advertisementsSearch) params.append('search', advertisementsSearch)

      const response = await axios.get(`/global-admin/advertisements?${params}`)
      setAdvertisements(response.data.advertisements || [])
      setAdvertisementsPagination({
        currentPage: response.data.currentPage || page,
        totalPages: response.data.totalPages || 1,
        total: response.data.total || 0,
        pageSize
      })
    } catch (error) {
      toast.error('Error loading advertisements')
      setAdvertisements([])
      setAdvertisementsPagination({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        pageSize
      })
    }
  }

  const fetchAdSenseConfig = async (page = 1, pageSize = adsensePagesPagination.pageSize) => {
    setAdSenseLoading(true)
    try {
      const response = await axios.get(`/adsense/global-admin/config?page=${page}&limit=${pageSize}`)
      setAdSenseConfig(response.data.config || null)
      setAdSensePages(response.data.pages || [])
      setAdSensePagesPagination({
        currentPage: response.data.currentPage || page,
        totalPages: response.data.totalPages || 1,
        total: response.data.total || 0,
        pageSize
      })
    } catch (error) {
      console.error('Error loading AdSense config:', error)
      toast.error('Error loading AdSense configuration')
      setAdSenseConfig(null)
      setAdSensePages([])
      setAdSensePagesPagination({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        pageSize
      })
    } finally {
      setAdSenseLoading(false)
    }
  }

  const updateAdSenseConfig = async (updates) => {
    // Validate before sending
    if (!validateAdSenseConfig()) {
      setAdSenseSaveAttempted(true)
      toast.error('Please fix the validation errors before saving')
      return
    }

    setAdSenseConfigLoading(true)
    setAdSenseSaveAttempted(false)

    try {
      const response = await axios.put('/adsense/global-admin/config', updates)

      if (response.data.success) {
        setAdSenseConfig(response.data.config || null)
        setAdSenseValidationErrors({})
        toast.success(response.data.message || 'AdSense configuration updated successfully')
      } else {
        // Handle validation errors from backend
        if (response.data.errors) {
          const errors = {}
          response.data.errors.forEach(error => {
            if (error.includes('Publisher ID')) errors.publisherId = error
            if (error.includes('Ad Client ID')) errors.adClientId = error
            if (error.includes('script')) errors.adScript = error
          })
          setAdSenseValidationErrors(errors)
          setAdSenseSaveAttempted(true)
          toast.error('Validation failed. Please check the errors below.')
        } else {
          toast.error(response.data.message || 'Error updating AdSense configuration')
        }
      }
    } catch (error) {
      console.error('Error updating AdSense config:', error)

      if (error.response?.data?.errors) {
        const errors = {}
        error.response.data.errors.forEach(err => {
          if (err.includes('Publisher ID')) errors.publisherId = err
          if (err.includes('Ad Client ID')) errors.adClientId = err
          if (err.includes('script')) errors.adScript = err
        })
        setAdSenseValidationErrors(errors)
        setAdSenseSaveAttempted(true)
        toast.error('Validation failed. Please check the errors below.')
      } else {
        toast.error(error.response?.data?.message || 'Error updating AdSense configuration')
      }
    } finally {
      setAdSenseConfigLoading(false)
    }
  }

  const toggleAdSensePageApproval = async (pageId, approved) => {
    setAdSensePageLoading(prev => ({ ...prev, [pageId]: true }))
    try {
      await axios.post('/adsense/global-admin/pages', { pageId, approved })
      toast.success(`Page ${approved ? 'approved' : 'revoked'} successfully`)
      await fetchAdSenseConfig(adsensePagesPagination.currentPage, adsensePagesPagination.pageSize)
    } catch (error) {
      console.error('Error updating AdSense page approval:', error)
      toast.error(error.response?.data?.message || 'Error updating page approval')
    } finally {
      setAdSensePageLoading(prev => ({ ...prev, [pageId]: false }))
    }
  }

  const fetchExtraPremiumRequests = async (page = 1, pageSize = premiumRequestsPagination.pageSize) => {
    setApplyingExtraPremiumSort(true)
    try {
      console.log('[GlobalAdmin] Fetching Extra Premium Layer requests...')
      const params = new URLSearchParams({
        page: page.toString(),
        limit: pageSize.toString(),
        sortBy: extraPremiumRequestsSortBy,
        sortOrder: extraPremiumRequestsSortOrder
      })

      if (extraPremiumRequestsSearch) {
        params.append('search', extraPremiumRequestsSearch)
      }

      const response = await axios.get(`/global-admin/extra-premium/requests?${params}`)
      const requests = response.data.requests || []
      console.log('[GlobalAdmin] Successfully loaded', requests.length, 'premium requests')
      setExtraPremiumRequests(requests)
      const selections = {}
      requests.forEach((request) => {
        selections[request.id] = {
          contact: !!request.allowedSections?.contact,
          products: !!request.allowedSections?.products,
          fixtures: !!request.allowedSections?.fixtures,
          resume: !!request.allowedSections?.resume,
          pointsTable: !!request.allowedSections?.pointsTable,
          cryptoProduct: !!request.allowedSections?.cryptoProduct,
          tickets: !!request.allowedSections?.tickets,
          donation: !!request.allowedSections?.donation
        }
      })
      setPremiumRequestSelections(selections)
      setPremiumRequestsPagination({
        currentPage: response.data.currentPage || page,
        totalPages: response.data.totalPages || 1,
        total: response.data.total || 0,
        pageSize
      })
    } catch (error) {
      console.error('Error loading Extra Premium Layer requests:', error)
      const errorMsg = error.response?.data?.message || error.message || 'Error loading premium requests'
      console.error('[GlobalAdmin] Error details:', {
        status: error.response?.status,
        message: errorMsg,
        url: error.config?.url,
        method: error.config?.method
      })
      toast.error(errorMsg)
      setExtraPremiumRequests([])
      setPremiumRequestSelections({})
      setPremiumRequestsPagination({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        pageSize
      })
    } finally {
      setApplyingExtraPremiumSort(false)
    }
  }

  const handlePremiumSelectionChange = async (requestId, sectionKey, value) => {
    const request = extraPremiumRequests.find(r => r.id === requestId)
    const isApproved = request?.status === 'approved'

    setPremiumRequestSelections((current) => ({
      ...current,
      [requestId]: {
        ...current[requestId],
        [sectionKey]: value
      }
    }))

    // Auto-save for approved requests
    if (isApproved) {
      try {
        const allowedSections = {
          ...premiumRequestSelections[requestId],
          [sectionKey]: value
        }
        await axios.put(`/global-admin/extra-premium/requests/${requestId}/sections`, { allowedSections })
        
        // Brief success message without full toast to avoid distraction
        console.log(`Section ${sectionKey} ${value ? 'enabled' : 'disabled'} - changes are live immediately`)
        
        // Re-fetch to ensure UI stays in sync, but don't wait for it
        fetchExtraPremiumRequests(premiumRequestsPagination.currentPage, premiumRequestsPagination.pageSize).catch(err => console.error('Error refreshing requests:', err))
      } catch (error) {
        console.error('Error updating section:', error)
        toast.error(error.response?.data?.message || 'Error updating section access')
        // Revert the change on error
        setPremiumRequestSelections((current) => ({
          ...current,
          [requestId]: {
            ...current[requestId],
            [sectionKey]: !value
          }
        }))
      }
    }
  }

  // Auto-refresh approved requests every 30 seconds to catch any manual DB changes
  useEffect(() => {
    if (activeTab !== 'premium') return

    const refreshInterval = setInterval(() => {
      if (extraPremiumRequests.length > 0) {
        fetchExtraPremiumRequests(premiumRequestsPagination.currentPage, premiumRequestsPagination.pageSize).catch(err => console.error('Auto-refresh error:', err))
      }
    }, 30000) // 30 seconds

    return () => clearInterval(refreshInterval)
  }, [activeTab, extraPremiumRequests.length])

  const handleApproveExtraPremiumRequest = async (requestId) => {
    setProcessingPremiumRequestId(requestId)
    try {
      const allowedSections = premiumRequestSelections[requestId] || {}
      if (!Object.values(allowedSections).some(Boolean)) {
        toast.error('Please enable at least one premium section before approval.')
        return
      }

      await axios.post(`/global-admin/extra-premium/requests/${requestId}/approve`, { allowedSections })
      toast.success('Extra Premium Layer request approved')
      await fetchExtraPremiumRequests(premiumRequestsPagination.currentPage, premiumRequestsPagination.pageSize)
      fetchPremiumData(premiumUsersPagination.currentPage, premiumUsersPagination.pageSize)
    } catch (error) {
      console.error('Error approving request:', error)
      toast.error(error.response?.data?.message || 'Error approving request')
    } finally {
      setProcessingPremiumRequestId(null)
    }
  }

  const handleRejectExtraPremiumRequest = async (requestId) => {
    const request = extraPremiumRequests.find(r => r.id === requestId)
    const isApproved = request?.status === 'approved'
    
    setProcessingPremiumRequestId(requestId)
    try {
      const deniedReason = isApproved ? 'Extra Premium Layer access unapproved by Global Admin' : 'Request rejected by Global Admin'
      await axios.post(`/global-admin/extra-premium/requests/${requestId}/reject`, { deniedReason })
      
      const successMessage = isApproved ? 'Extra Premium Layer access unapproved successfully' : 'Extra Premium Layer request rejected'
      toast.success(successMessage)
      
      await fetchExtraPremiumRequests(premiumRequestsPagination.currentPage, premiumRequestsPagination.pageSize)
      fetchPremiumData(premiumUsersPagination.currentPage, premiumUsersPagination.pageSize)
    } catch (error) {
      console.error('Error rejecting/unapproving request:', error)
      toast.error(error.response?.data?.message || 'Error processing request')
    } finally {
      setProcessingPremiumRequestId(null)
    }
  }

  const handleClearAllExtraPremiumRequests = async () => {
    if (!window.confirm('Are you sure you want to clear all Extra Premium Layer requests? This action cannot be undone.')) {
      return
    }

    setClearingAllRequests(true)
    try {
      await axios.delete('/global-admin/extra-premium/requests/clear-all')
      toast.success('All Extra Premium Layer requests cleared successfully')
      await fetchExtraPremiumRequests(premiumRequestsPagination.currentPage, premiumRequestsPagination.pageSize)
    } catch (error) {
      console.error('Error clearing requests:', error)
      toast.error(error.response?.data?.message || 'Error clearing requests')
    } finally {
      setClearingAllRequests(false)
    }
  }

  const handleDeleteExtraPremiumRequest = async (requestId) => {
    if (!window.confirm('Are you sure you want to delete this Extra Premium Layer request? This action cannot be undone.')) {
      return
    }

    setDeletingRequestId(requestId)
    try {
      await axios.delete(`/global-admin/extra-premium/requests/${requestId}`)
      toast.success('Extra Premium Layer request deleted successfully')
      await fetchExtraPremiumRequests(premiumRequestsPagination.currentPage, premiumRequestsPagination.pageSize)
    } catch (error) {
      console.error('Error deleting request:', error)
      toast.error(error.response?.data?.message || 'Error deleting request')
    } finally {
      setDeletingRequestId(null)
    }
  }

  const handleRefreshExtraPremiumRequests = async () => {
    setRefreshingPremiumRequests(true)
    try {
      await fetchExtraPremiumRequests(premiumRequestsPagination.currentPage, premiumRequestsPagination.pageSize)
      toast.success('Extra Premium Layer requests refreshed')
    } catch (error) {
      console.error('Error refreshing requests:', error)
      toast.error('Error refreshing requests')
    } finally {
      setRefreshingPremiumRequests(false)
    }
  }

  const fetchGlobalAdmins = async (page = 1, pageSize = globalAdminsPagination.pageSize) => {
    try {
      console.log('Fetching global admins...')
      const params = new URLSearchParams({
        page: page.toString(),
        limit: pageSize.toString(),
        sortBy: globalAdminsSortBy,
        sortOrder: globalAdminsSortOrder
      })

      if (globalAdminsSearch) params.append('search', globalAdminsSearch)

      const response = await axios.get(`/global-admin/admins?${params}`)
      console.log('Global admins response:', response.data)
      setGlobalAdmins(response.data.admins || [])
      setGlobalAdminsPagination({
        currentPage: response.data.currentPage || page,
        totalPages: response.data.totalPages || 1,
        total: response.data.total || 0,
        pageSize
      })
    } catch (error) {
      console.error('Error loading global admins:', error)
      if (error.response?.status === 403) {
        toast.error('Only the original Global Admin can view admin list')
      } else {
        toast.error('Error loading global admins')
      }
      setGlobalAdmins([])
      setGlobalAdminsPagination({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        pageSize
      })
    }
  }

  const fetchEscrowTickets = async () => {
    setRefreshingEscrowTickets(true)
    try {
      const response = await axios.get('/global-admin/escrow-tickets')
      setEscrowTickets(response.data.tickets || [])
    } catch (error) {
      toast.error('Error loading escrow tickets')
    } finally {
      setRefreshingEscrowTickets(false)
    }
  }

  const fetchActionLogs = async (page = 1) => {
    setLoadingActionLogs(true)
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: '10',
        sortBy: actionLogsSortBy,
        sortOrder: actionLogsSortOrder
      })

      if (actionLogsActionType !== 'all') params.append('actionType', actionLogsActionType)

      const response = await axios.get(`/global-admin/action-logs?${params}`)
      const data = response.data || {}
      setActionLogs(data.logs || [])
      setActionLogsPagination({
        currentPage: data.currentPage || 1,
        totalPages: data.totalPages || 1,
        total: data.total || 0
      })
    } catch (error) {
      console.error('Error fetching action logs:', error)
      toast.error('Error loading action logs')
      // Set empty state on error
      setActionLogs([])
      setActionLogsPagination({
        currentPage: 1,
        totalPages: 1,
        total: 0
      })
    } finally {
      setLoadingActionLogs(false)
    }
  }

  const clearActionLogs = async () => {
    if (!confirm('Are you sure you want to permanently delete all action logs? This action cannot be undone.')) return

    try {
      await axios.delete('/global-admin/action-logs')
      toast.success('All action logs cleared successfully')
      setActionLogs([])
      setActionLogsPagination({
        currentPage: 1,
        totalPages: 1,
        total: 0
      })
    } catch (error) {
      toast.error('Error clearing action logs')
    }
  }

  const deleteActionLog = async (logId) => {
    if (!confirm('Are you sure you want to permanently delete this action log? This action cannot be undone.')) return

    try {
      await axios.delete(`/global-admin/action-logs/${logId}`)
      toast.success('Action log deleted successfully')
      // Refresh the logs, staying on the same page or going back a page if needed
      fetchActionLogs(actionLogsPagination.currentPage || 1)
    } catch (error) {
      toast.error('Error deleting action log')
    }
  }

  const fetchEscrowTicketDetails = async (ticketId) => {
    try {
      const response = await axios.get(`/global-admin/escrow-tickets/${ticketId}`)
      setSelectedEscrowTicket(response.data)
    } catch (error) {
      toast.error('Error loading escrow ticket details')
    }
  }

  const fetchPremiumData = async (page = 1, pageSize = premiumUsersPagination.pageSize) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: pageSize.toString(),
        sortBy: premiumUsersSortBy,
        sortOrder: premiumUsersSortOrder
      })

      if (premiumUsersSearch) params.append('search', premiumUsersSearch)

      const response = await axios.get(`/global-admin/premium/users?${params}`)
      setPremiumUsers(response.data.users || [])
      setAppPremiumMode(response.data.appPremiumMode)
      setPremiumStats({
        totalUsers: response.data.totalUsers,
        premiumUsers: response.data.premiumUsers,
        freeUsers: response.data.freeUsers
      })
      setPremiumUsersPagination({
        currentPage: response.data.currentPage || page,
        totalPages: response.data.totalPages || 1,
        total: response.data.total || 0,
        pageSize
      })
    } catch (error) {
      toast.error('Error loading premium data')
      setPremiumUsers([])
      setPremiumUsersPagination({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        pageSize
      })
    }
  }

  const handleToggleAppPremiumMode = async () => {
    setToggleAppPremiumModeLoading(true)
    try {
      const response = await axios.post('/global-admin/premium/toggle-app-mode')
      setAppPremiumMode(response.data.appPremiumMode)
      toast.success(response.data.message)
      fetchPremiumData(premiumUsersPagination.currentPage, premiumUsersPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error toggling app mode')
    } finally {
      setToggleAppPremiumModeLoading(false)
    }
  }

  const handleUpgradeToPremium = async (userId) => {
    setUpgradingUserId(userId)
    try {
      await axios.post(`/global-admin/premium/upgrade/${userId}`)
      toast.success('User upgraded to premium')
      fetchPremiumData(premiumUsersPagination.currentPage, premiumUsersPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error upgrading user')
    } finally {
      setUpgradingUserId(null)
    }
  }

  const handleDowngradeFromPremium = async (userId) => {
    setDowngradingUserId(userId)
    try {
      await axios.post(`/global-admin/premium/downgrade/${userId}`)
      toast.success('User downgraded from premium')
      fetchPremiumData(premiumUsersPagination.currentPage, premiumUsersPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error downgrading user')
    } finally {
      setDowngradingUserId(null)
    }
  }

  const handleToggleUserStatus = async (userId) => {
    setTogglingStatusUserId(userId)
    try {
      await axios.patch(`/global-admin/users/${userId}/toggle-status`)
      toast.success('User status updated successfully')
      fetchUsers(usersPagination.currentPage, usersPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error updating user status')
    } finally {
      setTogglingStatusUserId(null)
    }
  }

  const handleToggleRecommendation = async (userId) => {
    setTogglingRecommendationUserId(userId)
    try {
      await axios.patch(`/global-admin/users/${userId}/toggle-recommendation`)
      toast.success('User recommendation status updated')
      fetchUsers(usersPagination.currentPage, usersPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error updating recommendation')
    } finally {
      setTogglingRecommendationUserId(null)
    }
  }

  const handleDeleteUser = async (userId) => {
    const confirmMessage = `WARNING: This will PERMANENTLY delete this user and ALL their associated data including:
- Profile information and settings
- All items and products
- Orders and payment history
- Websites and website content
- Notes and documents
- Bank details and billing addresses
- Support tickets and messages

This action CANNOT be undone. Type "DELETE" to confirm.`

    const userConfirm = prompt(confirmMessage)
    if (userConfirm !== 'DELETE') return

    if (!currentAdmin?.isOriginal) {
      toast.error('Only the original Global Admin can delete users')
      return
    }

    setDeletingUserId(userId)
    try {
      const response = await axios.delete(`/global-admin/users/${userId}`)
      toast.success('User permanently deleted from database')
      console.log('Deletion stats:', response.data.deletionStats)
      fetchUsers(usersPagination.currentPage, usersPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error deleting user')
    } finally {
      setDeletingUserId(null)
    }
  }

  const handleResetUserAdminPassword = async (userId) => {
    if (!currentAdmin?.isOriginal) {
      toast.error('Only the original Global Admin can reset admin passwords')
      return
    }

    setResettingPasswordUserId(userId)
    try {
      const response = await axios.post(`/global-admin/reset-user-password/${userId}`)
      toast.success(response.data?.message || 'User admin password reset successfully')
      if (response.data?.newPassword) {
        toast.success(`New password: ${response.data.newPassword}`)
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error resetting user admin password')
    } finally {
      setResettingPasswordUserId(null)
    }
  }

  const handleRecoverUser = async (userId) => {
    setRecoveringUserId(userId)
    try {
      await axios.patch(`/global-admin/users/${userId}/recover`)
      toast.success('User recovered successfully')
      fetchUsers(usersPagination.currentPage, usersPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error recovering user')
    } finally {
      setRecoveringUserId(null)
    }
  }

  const handleCreateAdmin = async (e) => {
    e.preventDefault()
    setCreateAdminLoading(true)
    
    try {
      console.log('Creating admin with data:', newAdminData)
      console.log('Current admin status:', currentAdmin)
      
      const response = await axios.post('/global-admin/create-admin', newAdminData)
      console.log('Create admin response:', response.data)
      
      toast.success('Global admin created successfully')
      setShowCreateAdminModal(false)
      setNewAdminData({ email: '', password: '' })
      fetchGlobalAdmins(globalAdminsPagination.currentPage, globalAdminsPagination.pageSize)
    } catch (error) {
      console.error('Error creating admin:', error.response?.data)
      toast.error(error.response?.data?.message || 'Error creating global admin')
    } finally {
      setCreateAdminLoading(false)
    }
  }

  const handleDeleteAdmin = async (adminId) => {
    if (!confirm('Are you sure you want to delete this global admin?')) return

    setDeletingAdminId(adminId)
    try {
      await axios.delete(`/global-admin/admins/${adminId}`)
      toast.success('Global admin deleted successfully')
      fetchGlobalAdmins(globalAdminsPagination.currentPage, globalAdminsPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error deleting global admin')
    } finally {
      setDeletingAdminId(null)
    }
  }

  const handleCreateAd = async (e) => {
    e.preventDefault()
    setCreatingAd(true)
    
    try {
      const formData = new FormData()
      formData.append('name', adFormData.name)
      formData.append('description', adFormData.description)
      formData.append('duration', adFormData.duration)
      formData.append('mediaUrl', adFormData.mediaUrl)
      
      if (adFile) {
        formData.append('media', adFile)
      }

      await axios.post('/global-admin/advertisements', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      
      toast.success('Advertisement created successfully')
      setShowAdForm(false)
      setAdFormData({ name: '', description: '', duration: 'week', mediaUrl: '' })
      setAdFile(null)
      fetchAdvertisements(advertisementsPagination.currentPage, advertisementsPagination.pageSize)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error creating advertisement')
    } finally {
      setCreatingAd(false)
    }
  }

  const handleSendMessage = async (e) => {
    e.preventDefault()
    setSendMessageLoading(true)
    
    try {
      await axios.post(`/global-admin/send-message/${selectedUser._id}`, messageData)
      toast.success('Message sent successfully')
      setShowMessageModal(false)
      setMessageData({ subject: '', message: '' })
      setSelectedUser(null)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error sending message')
    } finally {
      setSendMessageLoading(false)
    }
  }

  const handleBroadcastMessage = async (e) => {
    e.preventDefault()
    setBroadcastLoading(true)
    
    try {
      const response = await axios.post('/global-admin/broadcast-message', broadcastData)
      toast.success(`Broadcast sent to ${response.data.recipientCount} users`)
      setShowBroadcastModal(false)
      setBroadcastData({ subject: '', message: '' })
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error broadcasting message')
    } finally {
      setBroadcastLoading(false)
    }
  }

  const handleTicketReply = async (e) => {
    e.preventDefault()
    setReplyLoading(true)
    
    try {
      await axios.post(`/global-admin/tickets/${selectedTicket._id}/reply`, {
        message: replyMessage
      })
      toast.success('Reply sent successfully')
      setReplyMessage('')
      fetchTicketDetails(selectedTicket._id)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error sending reply')
    } finally {
      setReplyLoading(false)
    }
  }

  const handleDeleteTicket = async (ticketId) => {
    if (!confirm('Are you sure you want to delete this support ticket?')) return

    setDeletingTicketId(ticketId)
    try {
      await axios.delete(`/global-admin/tickets/${ticketId}`)
      toast.success('Support ticket deleted successfully')
      fetchTickets()
      if (selectedTicket?._id === ticketId) {
        setSelectedTicket(null)
      }
    } catch (error) {
      console.error('Delete ticket error:', error.response?.data)
      if (error.response?.status === 403) {
        toast.error('Only the original Global Admin can delete support tickets')
      } else {
        toast.error(error.response?.data?.message || 'Error deleting ticket')
      }
    } finally {
      setDeletingTicketId(null)
    }
  }

  const handleEscrowReply = async (e) => {
    e.preventDefault()
    setEscrowReplyLoading(true)
    
    try {
      await axios.post(`/global-admin/escrow-tickets/${selectedEscrowTicket._id}/message`, {
        message: escrowReplyMessage
      })
      toast.success('Message sent successfully')
      setEscrowReplyMessage('')
      fetchEscrowTicketDetails(selectedEscrowTicket._id)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error sending message')
    } finally {
      setEscrowReplyLoading(false)
    }
  }

  const handleDeleteEscrowTicket = async (ticketId) => {
    if (!confirm('Are you sure you want to permanently delete this escrow ticket? This action cannot be undone.')) return

    setDeletingEscrowTicketId(ticketId)
    try {
      await axios.delete(`/global-admin/escrow-tickets/${ticketId}`)
      toast.success('Escrow ticket permanently deleted successfully')
      fetchEscrowTickets()
      if (selectedEscrowTicket?._id === ticketId) {
        setSelectedEscrowTicket(null)
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error deleting escrow ticket')
    } finally {
      setDeletingEscrowTicketId(null)
    }
  }

  const handleDeleteAd = async (adId) => {
    if (!confirm('Are you sure you want to delete this advertisement?')) return

    setDeletingAdId(adId)
    try {
      await axios.delete(`/global-admin/advertisements/${adId}`)
      toast.success('Advertisement deleted successfully')
      fetchAdvertisements(advertisementsPagination.currentPage, advertisementsPagination.pageSize)
    } catch (error) {
      toast.error('Error deleting advertisement')
    } finally {
      setDeletingAdId(null)
    }
  }

  const tabs = [
    { id: 'dashboard', name: 'Dashboard', icon: Activity },
    { id: 'users', name: 'Users', icon: Users },
    { id: 'websites', name: 'Websites', icon: Globe },
    { id: 'premium', name: 'Premium Access', icon: Settings },
    { id: 'tickets', name: 'Support Tickets', icon: MessageSquare },
    { id: 'escrow', name: 'Escrow Tickets', icon: Shield },
    { id: 'advertisements', name: 'Advertisements', icon: Upload },
    ...(currentAdmin?.isOriginal ? [
      { id: 'adsense', name: 'AdSense Management', icon: Globe },
      { id: 'action-logs', name: 'Action Logs', icon: Activity },
      { id: 'admins', name: 'Global Admins', icon: UserPlus }
    ] : [])
  ]

  const formatRevenue = (revenueByCurrency) => {
    if (!revenueByCurrency || revenueByCurrency.length === 0) return '0'
    return revenueByCurrency.map(r => `${r.currency} ${Number(r.totalRevenue).toLocaleString()}`).join(' | ')
  }

  const statCards = [
    {
      title: 'Total Users',
      value: stats.totalUsers || 0,
      icon: Users,
      color: 'bg-blue-500'
    },
    {
      title: 'Active Users',
      value: stats.activeUsers || 0,
      icon: Users,
      color: 'bg-green-500'
    },
    {
      title: 'Total Items',
      value: stats.totalItems || 0,
      icon: Package,
      color: 'bg-purple-500'
    },
    {
      title: 'Total Revenue',
      value: formatRevenue(stats.revenueByCurrency) || '0',
      icon: DollarSign,
      color: 'bg-yellow-500'
    }
  ]

  const getUserAvatar = (user) => {
    if (!user) return `https://ui-avatars.com/api/?name=User&background=3b82f6&color=fff`
    
    const firstName = user.firstName || ''
    const lastName = user.lastName || ''
    const name = `${firstName}+${lastName}`.trim() || 'User'
    
    return user.profileImage || `https://ui-avatars.com/api/?name=${name}&background=3b82f6&color=fff`
  }

  const getUserDisplayName = (user) => {
    if (!user) return 'Unknown User'
    return `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Unknown User'
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <RefreshCw className="w-8 h-8 animate-spin text-blue-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Tab Navigation */}
        <div className="border-b border-gray-200 mb-8">
          <nav className="-mb-px flex space-x-8 overflow-x-auto">
            {tabs.map((tab) => {
              const Icon = tab.icon
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="w-4 h-4 mr-2" />
                  {tab.name}
                </button>
              )
            })}
          </nav>
        </div>

        {/* Dashboard Tab */}
        {activeTab === 'dashboard' && (
          <div>
            <div className="flex items-center justify-between mb-8">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Global Admin Dashboard</h1>
                <p className="text-gray-600">Manage your entire platform from here</p>
                {currentAdmin && (
                  <div className="mt-2 flex items-center space-x-2">
                    <span className="text-sm text-gray-500">Logged in as:</span>
                    <span className="text-sm font-medium text-gray-900">{currentAdmin.email}</span>
                    {currentAdmin.isOriginal && (
                      <span className="px-2 py-1 bg-red-100 text-red-800 text-xs font-medium rounded-full">
                        Original Admin
                      </span>
                    )}
                  </div>
                )}
              </div>
              <LoadingButton
                isLoading={false}
                onClick={() => setShowBroadcastModal(true)}
                title="Send broadcast message to all users"
              >
                Broadcast Message
              </LoadingButton>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              {statCards.map((card, index) => {
                const Icon = card.icon
                return (
                  <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                    <div className="flex items-center">
                      <div className={`p-3 rounded-lg ${card.color}`}>
                        <Icon className="w-6 h-6 text-white" />
                      </div>
                      <div className="ml-4">
                        <p className="text-sm font-medium text-gray-600">{card.title}</p>
                        <p className="text-2xl font-bold text-gray-900">
                          {card.value}
                        </p>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">System Overview</h3>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Platform Status</span>
                    <span className="text-green-600 font-medium">Operational</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Open Tickets</span>
                    <span className="font-medium">{stats.openTickets || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Total Tickets</span>
                    <span className="font-medium">{stats.totalTickets || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Escrow Tickets</span>
                    <span className="font-medium">{stats.totalEscrowTickets || 0}</span>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
                <div className="space-y-3">
                  <button
                    onClick={() => setActiveTab('users')}
                    className="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-center">
                      <Users className="w-5 h-5 text-blue-500 mr-3" />
                      <span>Manage Users</span>
                    </div>
                  </button>
                  <button
                    onClick={() => setActiveTab('tickets')}
                    className="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-center">
                      <MessageSquare className="w-5 h-5 text-green-500 mr-3" />
                      <span>Support Tickets</span>
                    </div>
                  </button>
                  <button
                    onClick={() => setActiveTab('escrow')}
                    className="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-center">
                      <Shield className="w-5 h-5 text-purple-500 mr-3" />
                      <span>Escrow Management</span>
                    </div>
                  </button>
                  {currentAdmin?.isOriginal && (
                    <button
                      onClick={() => setActiveTab('admins')}
                      className="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
                    >
                      <div className="flex items-center">
                        <UserPlus className="w-5 h-5 text-red-500 mr-3" />
                        <span>Manage Global Admins</span>
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Global Admins Tab - Only for Original Admin */}
        {activeTab === 'admins' && currentAdmin?.isOriginal && (
          <div>
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl font-semibold text-gray-900">Global Admin Management</h2>
                <p className="text-sm text-gray-600">Create and manage global administrator accounts</p>
              </div>
              <LoadingButton
                isLoading={false}
                onClick={() => setShowCreateAdminModal(true)}
                title="Create a new global administrator account"
              >
                <UserPlus className="w-4 h-4" />
                Create Global Admin
              </LoadingButton>
            </div>

            {/* Search and Sort Controls */}
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label htmlFor="globalAdminsSearch" className="block text-sm font-medium text-gray-700 mb-1">
                    Search Admins
                  </label>
                  <input
                    type="text"
                    id="globalAdminsSearch"
                    value={globalAdminsSearch}
                    onChange={(e) => setGlobalAdminsSearch(e.target.value)}
                    placeholder="Email, ID..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label htmlFor="globalAdminsSortBy" className="block text-sm font-medium text-gray-700 mb-1">
                    Sort By
                  </label>
                  <select
                    id="globalAdminsSortBy"
                    value={globalAdminsSortBy}
                    onChange={(e) => setGlobalAdminsSortBy(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="createdAt">Created Date</option>
                    <option value="email">Email</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="globalAdminsSortOrder" className="block text-sm font-medium text-gray-700 mb-1">
                    Order
                  </label>
                  <select
                    id="globalAdminsSortOrder"
                    value={globalAdminsSortOrder}
                    onChange={(e) => setGlobalAdminsSortOrder(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="desc">Newest First</option>
                    <option value="asc">Oldest First</option>
                  </select>
                </div>
              </div>
              <div className="flex justify-end mt-4">
                <LoadingButton
                  isLoading={false}
                  onClick={() => fetchGlobalAdmins(1, globalAdminsPagination.pageSize)}
                  title="Apply search and sort filters"
                >
                  Apply Filters
                </LoadingButton>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Admin Details
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Type
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Created
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Last Login
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {globalAdmins.map((admin) => (
                      <tr key={admin._id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div>
                            <div className="text-sm font-medium text-gray-900">
                              {admin.email}
                            </div>
                            <div className="text-sm text-gray-500">
                              ID: {admin._id}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                            admin.isOriginal 
                              ? 'bg-red-100 text-red-800' 
                              : 'bg-blue-100 text-blue-800'
                          }`}>
                            {admin.isOriginal ? 'Original Admin' : 'Created Admin'}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(admin.createdAt).toLocaleDateString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {admin.lastLogin ? new Date(admin.lastLogin).toLocaleDateString() : 'Never'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          {!admin.isOriginal && (
                            <IconButton
                              icon={Trash2}
                              isLoading={deletingAdminId === admin._id}
                              onClick={() => handleDeleteAdmin(admin._id)}
                              variant="danger"
                              title="Delete Admin"
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {globalAdmins.length > 0 && (
                <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
                  <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div className="text-sm text-gray-700">
                      Page {globalAdminsPagination.currentPage} of {globalAdminsPagination.totalPages} ({globalAdminsPagination.total} total)
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                      <label htmlFor="adminPageSize" className="text-sm text-gray-600">Show:</label>
                      <select
                        id="adminPageSize"
                        value={globalAdminsPagination.pageSize}
                        onChange={(e) => {
                          const newSize = parseInt(e.target.value, 10)
                          setGlobalAdminsPagination((prev) => ({ ...prev, pageSize: newSize }))
                          fetchGlobalAdmins(1, newSize)
                        }}
                        className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      {globalAdminsPagination.totalPages > 1 && (
                        <>
                          <button
                            onClick={() => fetchGlobalAdmins(1, globalAdminsPagination.pageSize)}
                            disabled={globalAdminsPagination.currentPage <= 1}
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            First
                          </button>
                          <button
                            onClick={() => fetchGlobalAdmins(globalAdminsPagination.currentPage - 1, globalAdminsPagination.pageSize)}
                            disabled={globalAdminsPagination.currentPage <= 1}
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Previous
                          </button>
                          <button
                            onClick={() => fetchGlobalAdmins(globalAdminsPagination.currentPage + 1, globalAdminsPagination.pageSize)}
                            disabled={globalAdminsPagination.currentPage >= globalAdminsPagination.totalPages}
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Next
                          </button>
                          <button
                            onClick={() => fetchGlobalAdmins(globalAdminsPagination.totalPages, globalAdminsPagination.pageSize)}
                            disabled={globalAdminsPagination.currentPage >= globalAdminsPagination.totalPages}
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Last
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {globalAdmins.length === 0 && (
                <div className="text-center py-8">
                  <UserPlus className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-600">No global admins found</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Users Tab */}
        {activeTab === 'users' && (
          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold text-gray-900">User Management</h2>
              <LoadingButton
                isLoading={refreshingUsers}
                onClick={() => fetchUsers(usersPagination.currentPage, usersPagination.pageSize)}
                loadingText="Refreshing..."
                title="Refresh users list"
              >
                Refresh
              </LoadingButton>
            </div>

            {/* Search and Filter Controls */}
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label htmlFor="usersSearch" className="block text-sm font-medium text-gray-700 mb-1">
                    Search Users
                  </label>
                  <input
                    type="text"
                    id="usersSearch"
                    value={usersSearch}
                    onChange={(e) => setUsersSearch(e.target.value)}
                    placeholder="Name, email..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label htmlFor="usersStatusFilter" className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                  </label>
                  <select
                    id="usersStatusFilter"
                    value={usersStatusFilter}
                    onChange={(e) => setUsersStatusFilter(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="all">All Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="usersSortBy" className="block text-sm font-medium text-gray-700 mb-1">
                    Sort By
                  </label>
                  <select
                    id="usersSortBy"
                    value={usersSortBy}
                    onChange={(e) => setUsersSortBy(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="createdAt">Join Date</option>
                    <option value="firstName">First Name</option>
                    <option value="lastName">Last Name</option>
                    <option value="email">Email</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="usersSortOrder" className="block text-sm font-medium text-gray-700 mb-1">
                    Order
                  </label>
                  <select
                    id="usersSortOrder"
                    value={usersSortOrder}
                    onChange={(e) => setUsersSortOrder(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="desc">Newest First</option>
                    <option value="asc">Oldest First</option>
                  </select>
                </div>
              </div>
              <div className="flex justify-end mt-4">
                <LoadingButton
                  isLoading={false}
                  onClick={() => fetchUsers(1, usersPagination.pageSize)}
                  title="Apply search and sort filters"
                >
                  Apply Filters
                </LoadingButton>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Admin</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Recommended</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Joined</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {users.map((user) => {
                      // Safety check for user object
                      if (!user || !user._id) return null;
                      
                      return (
                        <tr key={user._id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                              <img 
                                src={getUserAvatar(user)} 
                                alt="Profile" 
                                className="w-10 h-10 rounded-full mr-3" 
                              />
                              <div>
                                <div className="text-sm font-medium text-gray-900">
                                  {getUserDisplayName(user)}
                                </div>
                                <div className="text-sm text-gray-500">
                                  {user.email || 'No email'}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                              user.isActive 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-red-100 text-red-800'
                            }`}>
                              {user.isActive ? 'Active' : 'Disabled'}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                              user.adminConfig?.isAdmin 
                                ? 'bg-blue-100 text-blue-800' 
                                : 'bg-gray-100 text-gray-800'
                            }`}>
                              {user.adminConfig?.isAdmin ? 'Yes' : 'No'}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <button
                              onClick={() => handleToggleRecommendation(user._id)}
                              disabled={togglingRecommendationUserId === user._id}
                              className={`p-2 rounded-lg ${
                                user.isRecommended 
                                  ? 'text-yellow-600 hover:bg-yellow-50' 
                                  : 'text-gray-400 hover:bg-gray-50'
                              } ${togglingRecommendationUserId === user._id ? 'opacity-50 cursor-not-allowed' : ''}`}
                              title={user.isRecommended ? 'Remove Recommendation' : 'Mark as Recommended'}
                            >
                              {togglingRecommendationUserId === user._id ? (
                                <RefreshCw className="w-4 h-4 animate-spin" />
                              ) : (
                                <Star className={`w-4 h-4 ${user.isRecommended ? 'fill-current' : ''}`} />
                              )}
                            </button>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'Unknown'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                            <div className="flex space-x-2">
                              <IconButton
                                icon={user.isActive ? ToggleRight : ToggleLeft}
                                isLoading={togglingStatusUserId === user._id}
                                onClick={() => handleToggleUserStatus(user._id)}
                                variant={user.isActive ? 'danger' : 'success'}
                                title={user.isActive ? 'Disable User' : 'Enable User'}
                              />
                              <IconButton
                                icon={Send}
                                isLoading={false}
                                onClick={() => {
                                  setSelectedUser(user)
                                  setShowMessageModal(true)
                                }}
                                variant="primary"
                                title="Send Message"
                              />

                              {user.adminConfig?.isAdmin && currentAdmin?.isOriginal && !user.isDeleted && (
                                <IconButton
                                  icon={Key}
                                  isLoading={resettingPasswordUserId === user._id}
                                  onClick={() => handleResetUserAdminPassword(user._id)}
                                  variant="primary"
                                  title="Regenerate User Admin Password"
                                />
                              )}

                              {user.isDeleted ? (
                                <IconButton
                                  icon={RefreshCw}
                                  isLoading={recoveringUserId === user._id}
                                  onClick={() => handleRecoverUser(user._id)}
                                  variant="success"
                                  title="Recover User"
                                />
                              ) : (
                                currentAdmin?.isOriginal && (
                                  <IconButton
                                    icon={Trash2}
                                    isLoading={deletingUserId === user._id}
                                    onClick={() => handleDeleteUser(user._id)}
                                    variant="danger"
                                    title="Delete User"
                                  />
                                )
                              )}
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              {users.length === 0 && (
                <div className="text-center py-8">
                  <Users className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-600">No users found</p>
                </div>
              )}

              {users.length > 0 && (
                <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
                  <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <div className="text-sm text-gray-700">
                        Page {usersPagination.currentPage} of {usersPagination.totalPages} ({usersPagination.total} total users)
                      </div>
                      <div className="flex items-center gap-2">
                        <label htmlFor="pageSize" className="text-sm text-gray-600">Show:</label>
                        <select
                          id="pageSize"
                          value={usersPagination.pageSize}
                          onChange={(e) => {
                            const newPageSize = parseInt(e.target.value)
                            setUsersPagination(prev => ({ ...prev, pageSize: newPageSize }))
                            fetchUsers(1, newPageSize)
                          }}
                          className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                    </div>
                    {usersPagination.totalPages > 1 && (
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => fetchUsers(1, usersPagination.pageSize)}
                          disabled={usersPagination.currentPage <= 1}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed touch-target"
                          title="First Page"
                        >
                          First
                        </button>
                        <button
                          onClick={() => fetchUsers(usersPagination.currentPage - 1, usersPagination.pageSize)}
                          disabled={usersPagination.currentPage <= 1}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed touch-target"
                        >
                          Previous
                        </button>
                        <button
                          onClick={() => fetchUsers(usersPagination.currentPage + 1, usersPagination.pageSize)}
                          disabled={usersPagination.currentPage >= usersPagination.totalPages}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed touch-target"
                        >
                          Next
                        </button>
                        <button
                          onClick={() => fetchUsers(usersPagination.totalPages, usersPagination.pageSize)}
                          disabled={usersPagination.currentPage >= usersPagination.totalPages}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed touch-target"
                          title="Last Page"
                        >
                          Last
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Websites Tab */}
        {activeTab === 'websites' && (
          <GlobalAdminWebsites />
        )}

        {/* Premium Access Management Tab */}
        {activeTab === 'premium' ? (
          <div>
            {/* App-Level Mode Control */}
            <div className="mb-8">
              <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-6">App-Level Premium Mode Control</h2>
                
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <h3 className="font-semibold text-gray-900 mb-2">Current Mode</h3>
                      <p className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
                        appPremiumMode 
                          ? 'bg-purple-100 text-purple-800' 
                          : 'bg-amber-100 text-amber-800'
                      }`}>
                        {appPremiumMode ? '🔒 Premium Mode Active' : '🔓 Free Mode Active'}
                      </p>
                      <p className="text-sm text-gray-600 mt-3">
                        {appPremiumMode 
                          ? 'Only users marked as Premium can access the User Admin Dashboard' 
                          : 'All users can access the User Admin Dashboard, regardless of Premium status'}
                      </p>
                    </div>
                    <LoadingButton
                      variant={appPremiumMode ? 'warning' : 'primary'}
                      isLoading={toggleAppPremiumModeLoading}
                      onClick={handleToggleAppPremiumMode}
                      loadingText="Switching..."
                      title={appPremiumMode ? 'Switch to Free Mode' : 'Switch to Premium Mode'}
                    >
                      {appPremiumMode ? 'Switch to Free Mode' : 'Switch to Premium Mode'}
                    </LoadingButton>
                  </div>
                </div>

                {/* Mode Explanation */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                    <h4 className="font-semibold text-purple-900 mb-2">Premium Mode</h4>
                    <ul className="text-sm text-purple-700 space-y-2">
                      <li>✓ Only Premium users access Admin Dashboard</li>
                      <li>✓ Non-premium users are blocked</li>
                      <li>✓ Recommended for production</li>
                    </ul>
                  </div>
                  <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                    <h4 className="font-semibold text-amber-900 mb-2">Free Mode</h4>
                    <ul className="text-sm text-amber-700 space-y-2">
                      <li>✓ All users access Admin Dashboard</li>
                      <li>✓ Premium flags ignored</li>
                      <li>✓ Temporary/testing only</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Extra Premium Layer Requests */}
            <div className="bg-white rounded-lg shadow-md p-4 sm:p-6 mb-8">
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
                <div className="flex-1">
                  <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">Extra Premium Layer Requests</h2>
                  <p className="text-xs sm:text-sm text-gray-600">Review incoming Extra Premium Layer requests and grant access to premium website sections.</p>
                </div>
                <LoadingButton
                  isLoading={refreshingPremiumRequests}
                  onClick={handleRefreshExtraPremiumRequests}
                  loadingText="Refreshing..."
                  title="Refresh Extra Premium Layer Requests"
                  className="w-full sm:w-auto flex-shrink-0"
                >
                  Refresh
                </LoadingButton>
              </div>

              {/* Search and Sort Controls */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                  <div>
                    <label htmlFor="extraPremiumRequestsSearch" className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wide">
                      Search Requests
                    </label>
                    <input
                      type="text"
                      id="extraPremiumRequestsSearch"
                      value={extraPremiumRequestsSearch}
                      onChange={(e) => setExtraPremiumRequestsSearch(e.target.value)}
                      placeholder="Website name, user email..."
                      className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label htmlFor="extraPremiumRequestsSortBy" className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wide">
                      Sort By
                    </label>
                    <select
                      id="extraPremiumRequestsSortBy"
                      value={extraPremiumRequestsSortBy}
                      onChange={(e) => setExtraPremiumRequestsSortBy(e.target.value)}
                      className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                    >
                      <option value="requestedAt">Request Date</option>
                      <option value="status">Status</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="extraPremiumRequestsSortOrder" className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wide">
                      Order
                    </label>
                    <select
                      id="extraPremiumRequestsSortOrder"
                      value={extraPremiumRequestsSortOrder}
                      onChange={(e) => setExtraPremiumRequestsSortOrder(e.target.value)}
                      className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                    >
                      <option value="desc">Newest First</option>
                      <option value="asc">Oldest First</option>
                    </select>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row justify-end gap-2">
                  <LoadingButton
                    isLoading={applyingExtraPremiumSort}
                    onClick={() => fetchExtraPremiumRequests(1, premiumRequestsPagination.pageSize)}
                    loadingText="Applying..."
                    title="Apply search, filters, and sorting"
                    className="w-full sm:w-auto"
                  >
                    Apply Filters & Sort
                  </LoadingButton>
                </div>
              </div>

              {/* Desktop Table View */}
              <div className="hidden md:block overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Request</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Website</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Allowed Sections</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {extraPremiumRequests.map((request) => (
                      <tr key={request.id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-sm text-gray-900">
                          <div className="font-medium">{request.user?.firstName} {request.user?.lastName}</div>
                          <div className="text-xs text-gray-500">{request.user?.email}</div>
                          <div className="text-xs text-gray-500 mt-1">Requested {new Date(request.requestedAt).toLocaleString()}</div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-900">
                          <div className="font-medium">{request.website?.name || 'Unknown website'}</div>
                          <div className="text-xs text-gray-500">{request.website?.publicUrl}</div>
                        </td>
                        <td className="px-4 py-3">
                          <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                            request.status === 'pending' ? 'bg-amber-100 text-amber-800' :
                            request.status === 'approved' ? 'bg-green-100 text-green-800' :
                            'bg-red-100 text-red-800'
                          }`}>
                            {request.status.charAt(0).toUpperCase() + request.status.slice(1)}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <div className="grid grid-cols-2 gap-2">
                            {['contact', 'products', 'fixtures', 'resume', 'pointsTable', 'cryptoProduct', 'tickets', 'customerAuth', 'donation'].map((sectionKey) => (
                              <label key={sectionKey} className="flex items-center gap-2 text-xs cursor-pointer hover:text-indigo-600">
                                <input
                                  type="checkbox"
                                  disabled={request.status !== 'pending' && request.status !== 'approved'}
                                  checked={premiumRequestSelections[request.id]?.[sectionKey] || (request.status === 'approved' && request.allowedSections?.[sectionKey]) || false}
                                  onChange={(event) => handlePremiumSelectionChange(request.id, sectionKey, event.target.checked)}
                                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"
                                />
                                <span>{
                                  sectionKey === 'contact' ? 'Contact Us' :
                                  sectionKey === 'products' ? 'Product' :
                                  sectionKey === 'fixtures' ? 'Fixtures' :
                                  sectionKey === 'resume' ? 'Resume' :
                                  sectionKey === 'pointsTable' ? 'Points Table' :
                                  sectionKey === 'cryptoProduct' ? 'Crypto Product' :
                                  sectionKey === 'customerAuth' ? 'Customer Login' :
                                  sectionKey === 'donation' ? 'Donation' :
                                  'Ticket'
                                }</span>
                              </label>
                            ))}
                          </div>
                        </td>
                        <td className="px-4 py-3 space-y-2">
                          <div className="flex flex-wrap gap-2">
                            {request.status === 'pending' && (
                              <>
                                <LoadingButton
                                  variant="success"
                                  size="sm"
                                  isLoading={processingPremiumRequestId === request.id}
                                  onClick={() => handleApproveExtraPremiumRequest(request.id)}
                                  loadingText="Approving..."
                                  title="Approve Extra Premium Layer request"
                                >
                                  Approve
                                </LoadingButton>
                                <LoadingButton
                                  variant="danger"
                                  size="sm"
                                  isLoading={processingPremiumRequestId === request.id}
                                  onClick={() => handleRejectExtraPremiumRequest(request.id)}
                                  loadingText="Rejecting..."
                                  title="Reject Extra Premium Layer request"
                                >
                                  Reject
                                </LoadingButton>
                              </>
                            )}
                            {request.status === 'approved' && (
                              <LoadingButton
                                variant="danger"
                                size="sm"
                                isLoading={processingPremiumRequestId === request.id}
                                onClick={() => handleRejectExtraPremiumRequest(request.id)}
                                loadingText="Unapproving..."
                                title="Unapprove Extra Premium Layer access"
                              >
                                Unapprove
                              </LoadingButton>
                            )}
                            {request.status === 'rejected' && (
                              <span className="text-xs text-gray-500">Rejected</span>
                            )}
                          </div>
                          <LoadingButton
                            variant="secondary"
                            size="sm"
                            isLoading={deletingRequestId === request.id}
                            onClick={() => handleDeleteExtraPremiumRequest(request.id)}
                            loadingText="Deleting..."
                            title="Delete Extra Premium Layer request"
                            className="w-full"
                          >
                            Delete
                          </LoadingButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Card View */}
              <div className="md:hidden space-y-4">
                {extraPremiumRequests.map((request) => (
                  <div key={request.id} className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                    {/* Card Header */}
                    <div className="border-b border-gray-100 p-4">
                      <div className="flex items-start justify-between gap-3 mb-3">
                        <div className="flex-1 min-w-0">
                          <h3 className="text-sm font-semibold text-gray-900 truncate">
                            {request.user?.firstName} {request.user?.lastName}
                          </h3>
                          <p className="text-xs text-gray-500 truncate">{request.user?.email}</p>
                        </div>
                        <span className={`flex-shrink-0 px-2.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap ${
                          request.status === 'pending' ? 'bg-amber-100 text-amber-800' :
                          request.status === 'approved' ? 'bg-green-100 text-green-800' :
                          'bg-red-100 text-red-800'
                        }`}>
                          {request.status.charAt(0).toUpperCase() + request.status.slice(1)}
                        </span>
                      </div>
                      <p className="text-xs text-gray-600">
                        Requested: {new Date(request.requestedAt).toLocaleString()}
                      </p>
                    </div>

                    {/* Website Information */}
                    <div className="border-b border-gray-100 p-4">
                      <p className="text-xs font-medium text-gray-700 mb-1">Website</p>
                      <p className="text-sm font-semibold text-gray-900 break-words">{request.website?.name || 'Unknown website'}</p>
                      <p className="text-xs text-gray-500 break-all">{request.website?.publicUrl}</p>
                    </div>

                    {/* Allowed Sections */}
                    <div className="border-b border-gray-100 p-4">
                      <p className="text-xs font-medium text-gray-700 mb-3">Allowed Sections</p>
                      <div className="grid grid-cols-1 gap-3">
                        {['contact', 'products', 'fixtures', 'resume', 'pointsTable', 'cryptoProduct', 'tickets', 'customerAuth', 'donation'].map((sectionKey) => (
                          <label
                            key={sectionKey}
                            className="flex items-center gap-3 p-2 rounded-md hover:bg-gray-50 cursor-pointer transition-colors"
                          >
                            <input
                              type="checkbox"
                              disabled={request.status !== 'pending' && request.status !== 'approved'}
                              checked={premiumRequestSelections[request.id]?.[sectionKey] || (request.status === 'approved' && request.allowedSections?.[sectionKey]) || false}
                              onChange={(event) => handlePremiumSelectionChange(request.id, sectionKey, event.target.checked)}
                              className="h-5 w-5 text-indigo-600 border-gray-300 rounded cursor-pointer"
                            />
                            <span className="text-sm text-gray-900 font-medium">
                              {
                                sectionKey === 'contact' ? 'Contact Us' :
                                sectionKey === 'products' ? 'Product' :
                                sectionKey === 'fixtures' ? 'Fixtures' :
                                sectionKey === 'resume' ? 'Resume' :
                                sectionKey === 'pointsTable' ? 'Points Table' :
                                sectionKey === 'cryptoProduct' ? 'Crypto Product' :
                                sectionKey === 'customerAuth' ? 'Customer Login' :
                                sectionKey === 'donation' ? 'Donation' :
                                'Ticket'
                              }
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="p-4 bg-gray-50 rounded-b-lg">
                      <div className="space-y-2">
                        {request.status === 'pending' && (
                          <>
                            <LoadingButton
                              variant="success"
                              isLoading={processingPremiumRequestId === request.id}
                              onClick={() => handleApproveExtraPremiumRequest(request.id)}
                              loadingText="Approving..."
                              title="Approve Extra Premium Layer request"
                              className="w-full"
                            >
                              Approve Request
                            </LoadingButton>
                            <LoadingButton
                              variant="danger"
                              isLoading={processingPremiumRequestId === request.id}
                              onClick={() => handleRejectExtraPremiumRequest(request.id)}
                              loadingText="Rejecting..."
                              title="Reject Extra Premium Layer request"
                              className="w-full"
                            >
                              Reject Request
                            </LoadingButton>
                          </>
                        )}
                        {request.status === 'approved' && (
                          <LoadingButton
                            variant="danger"
                            isLoading={processingPremiumRequestId === request.id}
                            onClick={() => handleRejectExtraPremiumRequest(request.id)}
                            loadingText="Unapproving..."
                            title="Unapprove Extra Premium Layer access"
                            className="w-full"
                          >
                            Unapprove Access
                          </LoadingButton>
                        )}
                        {request.status === 'rejected' && (
                          <div className="text-center py-3 text-xs text-gray-500 bg-gray-100 rounded">
                            This request has been rejected
                          </div>
                        )}
                        <LoadingButton
                          variant="secondary"
                          isLoading={deletingRequestId === request.id}
                          onClick={() => handleDeleteExtraPremiumRequest(request.id)}
                          loadingText="Deleting..."
                          title="Delete Extra Premium Layer request"
                          className="w-full"
                        >
                          Delete Request
                        </LoadingButton>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {extraPremiumRequests.length > 0 && (
                <div className="mt-6 px-4 py-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">
                  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div className="text-xs sm:text-sm text-gray-700 font-medium">
                      Page <span className="font-bold text-gray-900">{premiumRequestsPagination.currentPage}</span> of <span className="font-bold text-gray-900">{premiumRequestsPagination.totalPages}</span> <span className="text-gray-600">({premiumRequestsPagination.total} requests)</span>
                    </div>
                    <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-2 w-full sm:w-auto">
                      <label htmlFor="requestsPageSize" className="text-xs sm:text-sm text-gray-600 font-medium">Show:</label>
                      <select
                        id="requestsPageSize"
                        value={premiumRequestsPagination.pageSize}
                        onChange={(e) => {
                          const newSize = parseInt(e.target.value, 10)
                          setPremiumRequestsPagination((prev) => ({ ...prev, pageSize: newSize }))
                          fetchExtraPremiumRequests(1, newSize)
                        }}
                        className="text-xs sm:text-sm border border-gray-300 rounded px-2 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      {premiumRequestsPagination.totalPages > 1 && (
                        <div className="flex flex-wrap gap-1 w-full sm:w-auto">
                          <button
                            onClick={() => fetchExtraPremiumRequests(1, premiumRequestsPagination.pageSize)}
                            disabled={premiumRequestsPagination.currentPage <= 1}
                            className="px-2 py-1.5 sm:px-3 sm:py-1 text-xs bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex-1 sm:flex-none min-w-max"
                            title="Go to first page"
                          >
                            First
                          </button>
                          <button
                            onClick={() => fetchExtraPremiumRequests(premiumRequestsPagination.currentPage - 1, premiumRequestsPagination.pageSize)}
                            disabled={premiumRequestsPagination.currentPage <= 1}
                            className="px-2 py-1.5 sm:px-3 sm:py-1 text-xs bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex-1 sm:flex-none min-w-max"
                            title="Go to previous page"
                          >
                            Prev
                          </button>
                          <button
                            onClick={() => fetchExtraPremiumRequests(premiumRequestsPagination.currentPage + 1, premiumRequestsPagination.pageSize)}
                            disabled={premiumRequestsPagination.currentPage >= premiumRequestsPagination.totalPages}
                            className="px-2 py-1.5 sm:px-3 sm:py-1 text-xs bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex-1 sm:flex-none min-w-max"
                            title="Go to next page"
                          >
                            Next
                          </button>
                          <button
                            onClick={() => fetchExtraPremiumRequests(premiumRequestsPagination.totalPages, premiumRequestsPagination.pageSize)}
                            disabled={premiumRequestsPagination.currentPage >= premiumRequestsPagination.totalPages}
                            className="px-2 py-1.5 sm:px-3 sm:py-1 text-xs bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex-1 sm:flex-none min-w-max"
                            title="Go to last page"
                          >
                            Last
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {extraPremiumRequests.length === 0 && (
                <div className="text-center py-8 sm:py-12 px-4 text-xs sm:text-sm text-gray-600 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="mb-1">No Extra Premium Layer requests at the moment.</p>
                  <p className="text-gray-500 text-xs">All requests have been resolved or cleared.</p>
                </div>
              )}

              {extraPremiumRequests.length > 0 && (
                <div className="mt-4 flex justify-center sm:justify-end">
                  <LoadingButton
                    variant="danger"
                    isLoading={clearingAllRequests}
                    onClick={handleClearAllExtraPremiumRequests}
                    loadingText="Clearing..."
                    title="Clear all Extra Premium Layer requests"
                    className="w-full sm:w-auto"
                  >
                    Clear All Requests
                  </LoadingButton>
                </div>
              )}
            </div>

            {/* User-Level Premium Control */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">User-Level Premium Management</h2>
              
              {/* Search and Sort Controls */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div>
                  <label htmlFor="premiumUsersSearch" className="block text-sm font-medium text-gray-700 mb-1">
                    Search Users
                  </label>
                  <input
                    type="text"
                    id="premiumUsersSearch"
                    value={premiumUsersSearch}
                    onChange={(e) => setPremiumUsersSearch(e.target.value)}
                    placeholder="Name, email..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label htmlFor="premiumUsersSortBy" className="block text-sm font-medium text-gray-700 mb-1">
                    Sort By
                  </label>
                  <select
                    id="premiumUsersSortBy"
                    value={premiumUsersSortBy}
                    onChange={(e) => setPremiumUsersSortBy(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="createdAt">Join Date</option>
                    <option value="firstName">First Name</option>
                    <option value="lastName">Last Name</option>
                    <option value="email">Email</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="premiumUsersSortOrder" className="block text-sm font-medium text-gray-700 mb-1">
                    Order
                  </label>
                  <select
                    id="premiumUsersSortOrder"
                    value={premiumUsersSortOrder}
                    onChange={(e) => setPremiumUsersSortOrder(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="desc">Newest First</option>
                    <option value="asc">Oldest First</option>
                  </select>
                </div>
              </div>
              <div className="flex justify-end mb-6">
                <LoadingButton
                  isLoading={false}
                  onClick={() => fetchPremiumData(1, premiumUsersPagination.pageSize)}
                  title="Apply search and sort filters"
                >
                  Apply Filters
                </LoadingButton>
              </div>
              
              {/* Premium Statistics */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200">
                  <p className="text-sm text-blue-700 font-medium">Total Users</p>
                  <p className="text-2xl font-bold text-blue-900">{premiumStats.totalUsers}</p>
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-4 border border-purple-200">
                  <p className="text-sm text-purple-700 font-medium">Premium Users</p>
                  <p className="text-2xl font-bold text-purple-900">{premiumStats.premiumUsers}</p>
                </div>
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-4 border border-gray-200">
                  <p className="text-sm text-gray-700 font-medium">Free Users</p>
                  <p className="text-2xl font-bold text-gray-900">{premiumStats.freeUsers}</p>
                </div>
              </div>

              {/* Users Table */}
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Premium</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Joined</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {premiumUsers.map((user) => (
                      <tr key={user.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div>
                            <p className="text-sm font-medium text-gray-900">
                              {user.firstName} {user.lastName}
                            </p>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {user.email}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                            user.isActive 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-red-100 text-red-800'
                          }`}>
                            {user.isActive ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                            user.isPremium 
                              ? 'bg-purple-100 text-purple-800' 
                              : 'bg-gray-100 text-gray-800'
                          }`}>
                            {user.isPremium ? '✓ Premium' : 'Free'}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(user.createdAt).toLocaleDateString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <div className="flex gap-2">
                            {user.isPremium ? (
                              <LoadingButton
                                variant="warning"
                                size="sm"
                                isLoading={downgradingUserId === user.id}
                                onClick={() => handleDowngradeFromPremium(user.id)}
                                loadingText="Downgrading..."
                                title="Downgrade from Premium"
                              >
                                Downgrade
                              </LoadingButton>
                            ) : (
                              <LoadingButton
                                variant="primary"
                                size="sm"
                                isLoading={upgradingUserId === user.id}
                                onClick={() => handleUpgradeToPremium(user.id)}
                                loadingText="Upgrading..."
                                title="Upgrade to Premium"
                              >
                                Upgrade
                              </LoadingButton>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {premiumUsers.length > 0 && (
                <div className="mt-6 px-4 py-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">
                  <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div className="text-sm text-gray-700">
                      Page {premiumUsersPagination.currentPage} of {premiumUsersPagination.totalPages} ({premiumUsersPagination.total} users)
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                      <label htmlFor="premiumPageSize" className="text-sm text-gray-600">Show:</label>
                      <select
                        id="premiumPageSize"
                        value={premiumUsersPagination.pageSize}
                        onChange={(e) => {
                          const newSize = parseInt(e.target.value, 10)
                          setPremiumUsersPagination((prev) => ({ ...prev, pageSize: newSize }))
                          fetchPremiumData(1, newSize)
                        }}
                        className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      {premiumUsersPagination.totalPages > 1 && (
                        <>
                          <button
                            onClick={() => fetchPremiumData(1, premiumUsersPagination.pageSize)}
                            disabled={premiumUsersPagination.currentPage <= 1}
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            First
                          </button>
                          <button
                            onClick={() => fetchPremiumData(premiumUsersPagination.currentPage - 1, premiumUsersPagination.pageSize)}
                            disabled={premiumUsersPagination.currentPage <= 1}
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Previous
                          </button>
                          <button
                            onClick={() => fetchPremiumData(premiumUsersPagination.currentPage + 1, premiumUsersPagination.pageSize)}
                            disabled={premiumUsersPagination.currentPage >= premiumUsersPagination.totalPages}
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Next
                          </button>
                          <button
                            onClick={() => fetchPremiumData(premiumUsersPagination.totalPages, premiumUsersPagination.pageSize)}
                            disabled={premiumUsersPagination.currentPage >= premiumUsersPagination.totalPages}
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Last
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {premiumUsers.length === 0 && (
                <div className="text-center py-12">
                  <Users className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-600">No users found</p>
                </div>
              )}
            </div>
          </div>
        ) : null}

        {/* Action Logs Tab */}
        {activeTab === 'action-logs' && (
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-2xl font-bold text-gray-900">Admin Action Logs</h2>
                <p className="text-gray-600">Monitor all global admin activities</p>
              </div>
              <div className="flex space-x-3">
                <LoadingButton
                  isLoading={loadingActionLogs}
                  onClick={fetchActionLogs}
                  loadingText="Refreshing..."
                  title="Refresh action logs"
                >
                  Refresh
                </LoadingButton>
                <LoadingButton
                  variant="danger"
                  onClick={clearActionLogs}
                  title="Clear all action logs"
                >
                  Clear All Logs
                </LoadingButton>
              </div>
            </div>

            {/* Filter and Sort Controls */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label htmlFor="actionLogsActionType" className="block text-sm font-medium text-gray-700 mb-1">
                    Action Type
                  </label>
                  <select
                    id="actionLogsActionType"
                    value={actionLogsActionType}
                    onChange={(e) => setActionLogsActionType(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="all">All Actions</option>
                    <option value="user-status-change">User Status Change</option>
                    <option value="user-premium-change">User Premium Change</option>
                    <option value="admin-created">Admin Created</option>
                    <option value="admin-deleted">Admin Deleted</option>
                    <option value="advertisement-created">Ad Created</option>
                    <option value="advertisement-deleted">Ad Deleted</option>
                    <option value="ticket-response">Ticket Response</option>
                    <option value="escrow-ticket-response">Escrow Response</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="actionLogsSortBy" className="block text-sm font-medium text-gray-700 mb-1">
                    Sort By
                  </label>
                  <select
                    id="actionLogsSortBy"
                    value={actionLogsSortBy}
                    onChange={(e) => setActionLogsSortBy(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="timestamp">Timestamp</option>
                    <option value="actionType">Action Type</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="actionLogsSortOrder" className="block text-sm font-medium text-gray-700 mb-1">
                    Order
                  </label>
                  <select
                    id="actionLogsSortOrder"
                    value={actionLogsSortOrder}
                    onChange={(e) => setActionLogsSortOrder(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="desc">Newest First</option>
                    <option value="asc">Oldest First</option>
                  </select>
                </div>
              </div>
              <div className="flex justify-end mt-4">
                <LoadingButton
                  isLoading={false}
                  onClick={() => fetchActionLogs(1)}
                  title="Apply search and sort filters"
                >
                  Apply Filters
                </LoadingButton>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Recent Actions</h3>
              </div>

              <div className="divide-y divide-gray-200">
                {actionLogs.length > 0 ? (
                  actionLogs.map((log) => (
                    <div key={log?._id || log?.logId || Math.random()} className="px-6 py-4 hover:bg-gray-50">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center space-x-3 mb-2">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                              {(log?.actionType || 'unknown').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                            </span>
                            <span className="text-sm text-gray-500">
                              {log?.adminId?.email || 'Unknown Admin'}
                            </span>
                            <span className="text-sm text-gray-500">
                              {log?.timestamp ? new Date(log.timestamp).toLocaleString() : 'Unknown Time'}
                            </span>
                          </div>
                          
                          <div className="text-sm text-gray-900 mb-1">
                            {log.targetDetails?.name && (
                              <span className="font-medium">{log.targetDetails.name}</span>
                            )}
                            {log.targetDetails?.email && (
                              <span className="text-gray-600"> ({log.targetDetails.email})</span>
                            )}
                            {log.targetDetails?.subject && (
                              <span className="text-gray-600"> - {log.targetDetails.subject}</span>
                            )}
                          </div>
                          
                          {log.reason && (
                            <p className="text-sm text-gray-600 mt-1">
                              Reason: {log.reason}
                            </p>
                          )}
                          
                          {log.notes && (
                            <p className="text-sm text-gray-600 mt-1">
                              Notes: {log.notes}
                            </p>
                          )}
                          
                          <div className="text-xs text-gray-500 mt-2">
                            Target: {log.targetType} • Log ID: {log.logId}
                            {log.ipAddress && ` • IP: ${log.ipAddress}`}
                          </div>
                        </div>
                        <div className="ml-4">
                          <button
                            onClick={() => log?.logId && deleteActionLog(log.logId)}
                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            title="Delete this log entry"
                            disabled={!log?.logId}
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="px-6 py-12 text-center">
                    <Activity className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-600">No action logs found</p>
                  </div>
                )}
              </div>

              {actionLogs.length > 0 && (
                <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
                  <div className="flex items-center justify-between">
                    <div className="text-sm text-gray-700">
                      Page {actionLogsPagination.currentPage} of {actionLogsPagination.totalPages}
                    </div>
                    {actionLogsPagination.totalPages > 1 && (
                      <div className="flex space-x-2">
                        <button
                          onClick={() => fetchActionLogs(actionLogsPagination.currentPage - 1)}
                          disabled={actionLogsPagination.currentPage <= 1}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Previous
                        </button>
                        <button
                          onClick={() => fetchActionLogs(actionLogsPagination.currentPage + 1)}
                          disabled={actionLogsPagination.currentPage >= actionLogsPagination.totalPages}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Support Tickets Tab */}
        {activeTab === 'tickets' && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Tickets List */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-semibold text-gray-900">Support Ticket</h3>
                  <button 
                    onClick={fetchTickets} 
                    disabled={refreshingTickets}
                    className={`text-gray-400 hover:text-gray-600 ${refreshingTickets ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    <RefreshCw className={`w-4 h-4 ${refreshingTickets ? 'animate-spin' : ''}`} />
                  </button>
                </div>
                
                {tickets.length > 0 ? (
                  <div className="space-y-3 max-h-96 overflow-y-auto">
                    {tickets.map((ticket) => (
                      <div
                        key={ticket._id}
                        onClick={() => fetchTicketDetails(ticket._id)}
                        className={`p-4 border rounded-lg cursor-pointer transition-colors hover:bg-gray-50 ${
                          selectedTicket?._id === ticket._id ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
                        }`}
                      >
                        <div className="flex items-start justify-between mb-2">
                          <h4 className="font-medium text-gray-900 text-sm line-clamp-1">
                            {ticket.subject}
                          </h4>
                          <div className="flex items-center space-x-1">
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                              ticket.status === 'open' ? 'bg-blue-100 text-blue-800' :
                              ticket.status === 'in-progress' ? 'bg-yellow-100 text-yellow-800' :
                              ticket.status === 'resolved' ? 'bg-green-100 text-green-800' :
                              'bg-gray-100 text-gray-800'
                            }`}>
                              {ticket.status.replace('-', ' ')}
                            </span>
                            {ticket.type === 'public' && (
                              <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                Public
                              </span>
                            )}
                          </div>
                        </div>
                        
                        <p className="text-sm text-gray-600 mb-2">
                          {ticket.displayName} ({ticket.displayEmail})
                        </p>
                        
                        <p className="text-xs text-gray-500">
                          {new Date(ticket.createdAt).toLocaleDateString()}
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <MessageSquare className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-600">No support tickets yet</p>
                  </div>
                )}
              </div>
            </div>

            {/* Ticket Details */}
            <div className="lg:col-span-2">
              {selectedTicket ? (
                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-start justify-between mb-6">
                    <div>
                      <h2 className="text-xl font-semibold text-gray-900 mb-2">
                        {selectedTicket.subject}
                      </h2>
                      <div className="flex items-center space-x-3">
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                          selectedTicket.status === 'open' ? 'bg-blue-100 text-blue-800' :
                          selectedTicket.status === 'in-progress' ? 'bg-yellow-100 text-yellow-800' :
                          selectedTicket.status === 'resolved' ? 'bg-green-100 text-green-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {selectedTicket.status.replace('-', ' ')}
                        </span>
                        <span className="text-sm text-gray-500">
                          From: {selectedTicket.displayName} ({selectedTicket.displayEmail})
                        </span>
                        {selectedTicket.type === 'public' && (
                          <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                            Public Support
                          </span>
                        )}
                      </div>
                    </div>
                    
                    {currentAdmin?.isOriginal && (
                      <button
                        onClick={() => handleDeleteTicket(selectedTicket._id)}
                        disabled={deletingTicketId === selectedTicket._id}
                        className={`text-red-600 hover:text-red-700 text-sm ${deletingTicketId === selectedTicket._id ? 'opacity-50 cursor-not-allowed' : ''}`}
                        title="Delete Ticket (Original Admin Only)"
                      >
                        {deletingTicketId === selectedTicket._id ? (
                          <RefreshCw className="w-4 h-4 animate-spin" />
                        ) : (
                          <Trash2 className="w-4 h-4" />
                        )}
                      </button>
                    )}
                  </div>

                  {/* Messages */}
                  <div className="space-y-4 mb-6 max-h-96 overflow-y-auto">
                    {selectedTicket.messages?.map((message, index) => (
                      <div
                        key={index}
                        className={`flex ${message.sender === 'admin' ? 'justify-end' : 'justify-start'}`}
                      >
                        <div
                          className={`max-w-xs lg:max-w-md px-4 py-3 rounded-lg ${
                            message.sender === 'admin'
                              ? 'bg-blue-600 text-white'
                              : 'bg-gray-100 text-gray-900'
                          }`}
                        >
                          <p className="text-sm">{message.message}</p>
                          <p className={`text-xs mt-1 ${
                            message.sender === 'admin' ? 'text-blue-100' : 'text-gray-500'
                          }`}>
                            {message.sender === 'admin' ? 'Admin' : 'User'} • {' '}
                            {new Date(message.timestamp).toLocaleString()}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Reply Form */}
                  {selectedTicket.status !== 'closed' && (
                    <form onSubmit={handleTicketReply} className="border-t pt-4">
                      <div className="flex space-x-3">
                        <textarea
                          value={replyMessage}
                          onChange={(e) => setReplyMessage(e.target.value)}
                          placeholder="Type your reply..."
                          rows="3"
                          className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                          required
                        />
                        <LoadingButton
                          type="submit"
                          disabled={!replyMessage.trim()}
                          isLoading={replyLoading}
                          loadingText=""
                          size="sm"
                          title="Send reply message"
                        >
                          <CornerUpLeft className="w-4 h-4" />
                        </LoadingButton>
                      </div>
                    </form>
                  )}
                </div>
              ) : (
                <div className="bg-white rounded-lg shadow-md p-6 text-center py-12">
                  <MessageSquare className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">
                    Select a ticket to view details
                  </h3>
                  <p className="text-gray-600">
                    Choose a ticket from the list to see the conversation
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Escrow Tickets Tab */}
        {activeTab === 'escrow' && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Escrow Tickets List */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-semibold text-gray-900">Escrow Tickets</h3>
                  <button 
                    onClick={fetchEscrowTickets} 
                    disabled={refreshingEscrowTickets}
                    className={`text-gray-400 hover:text-gray-600 ${refreshingEscrowTickets ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    <RefreshCw className={`w-4 h-4 ${refreshingEscrowTickets ? 'animate-spin' : ''}`} />
                  </button>
                </div>
                {escrowTickets.length > 0 ? (
                  <div className="space-y-3 max-h-96 overflow-y-auto">
                    {escrowTickets.map((ticket) => {
                      // Safety check for ticket object
                      if (!ticket || !ticket._id) return null;
                      
                      return (
                        <div 
                          key={ticket._id} 
                          onClick={() => fetchEscrowTicketDetails(ticket._id)} 
                          className={`p-4 border rounded-lg cursor-pointer transition-colors hover:bg-gray-50 ${
                            selectedEscrowTicket?._id === ticket._id ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
                          }`}
                        >
                          <div className="flex items-start justify-between mb-2">
                            <h4 className="font-medium text-gray-900 text-sm line-clamp-1">
                              {ticket.title || 'Escrow Ticket'}
                            </h4>
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                              ticket.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                              ticket.status === 'active' ? 'bg-green-100 text-green-800' :
                              ticket.status === 'closed' ? 'bg-gray-100 text-gray-800' :
                              'bg-red-100 text-red-800'
                            }`}>
                              {ticket.status}
                            </span>
                          </div>
                          
                          {ticket?.initiatorId && (
                            <div className="flex items-center space-x-2 mb-2">
                              <img
                                src={ticket.initiatorId.profileImage || `https://ui-avatars.com/api/?name=${ticket.initiatorId.firstName || 'User'}+${ticket.initiatorId.lastName || ''}&background=3b82f6&color=fff`}
                                alt="Initiator"
                                className="w-6 h-6 rounded-full"
                              />
                              <span className="text-xs text-gray-600">↔</span>
                              {ticket?.recipientId && (
                                <img
                                  src={ticket.recipientId.profileImage || `https://ui-avatars.com/api/?name=${ticket.recipientId.firstName || 'User'}+${ticket.recipientId.lastName || ''}&background=3b82f6&color=fff`}
                                  alt="Recipient"
                                  className="w-6 h-6 rounded-full"
                                />
                              )}
                            </div>
                          )}

                          {ticket?.transactionAmount > 0 && (
                            <p className="text-sm font-medium text-green-600 mb-2">
                              {ticket?.currency || 'NGN'} {ticket.transactionAmount.toLocaleString()}
                            </p>
                          )}
                          
                          <p className="text-xs text-gray-500">
                            {new Date(ticket?.lastActivity || ticket?.createdAt).toLocaleDateString()}
                          </p>
                        </div>
                      )
                    })}
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <Shield className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-600">No escrow tickets yet</p>
                  </div>
                )}
              </div>
            </div>

            {/* Escrow Ticket Details */}
            <div className="lg:col-span-2">
              {selectedEscrowTicket ? (
                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-start justify-between mb-6">
                    <div>
                      <h2 className="text-xl font-semibold text-gray-900 mb-2">
                        {selectedEscrowTicket.title}
                      </h2>
                      <div className="flex items-center space-x-3 mb-3">
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                          selectedEscrowTicket?.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                          selectedEscrowTicket?.status === 'active' ? 'bg-green-100 text-green-800' :
                          selectedEscrowTicket?.status === 'closed' ? 'bg-gray-100 text-gray-800' :
                          'bg-red-100 text-red-800'
                        }`}>
                          {selectedEscrowTicket?.status}
                        </span>
                        <span className="text-sm text-gray-500">
                          {selectedEscrowTicket?.category?.replace('-', ' ')}
                        </span>
                      </div>
                      
                      {selectedEscrowTicket?.initiatorId && (
                        <div className="flex items-center space-x-4 mb-4">
                          <div className="flex items-center space-x-2">
                            <img
                              src={selectedEscrowTicket.initiatorId.profileImage || `https://ui-avatars.com/api/?name=${selectedEscrowTicket.initiatorId.firstName || 'User'}+${selectedEscrowTicket.initiatorId.lastName || ''}&background=3b82f6&color=fff`}
                              alt="Initiator"
                              className="w-8 h-8 rounded-full"
                            />
                            <div>
                              <p className="text-sm font-medium text-gray-900">
                                {selectedEscrowTicket.initiatorId.firstName} {selectedEscrowTicket.initiatorId.lastName}
                              </p>
                              <p className="text-xs text-gray-500">Initiator</p>
                            </div>
                          </div>
                          
                          <span className="text-gray-400">↔</span>
                          
                          {selectedEscrowTicket?.recipientId && (
                            <div className="flex items-center space-x-2">
                              <img
                                src={selectedEscrowTicket.recipientId.profileImage || `https://ui-avatars.com/api/?name=${selectedEscrowTicket.recipientId.firstName || 'User'}+${selectedEscrowTicket.recipientId.lastName || ''}&background=3b82f6&color=fff`}
                                alt="Recipient"
                                className="w-8 h-8 rounded-full"
                              />
                              <div>
                                <p className="text-sm font-medium text-gray-900">
                                  {selectedEscrowTicket.recipientId.firstName} {selectedEscrowTicket.recipientId.lastName}
                                </p>
                                <p className="text-xs text-gray-500">Recipient</p>
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {selectedEscrowTicket?.transactionAmount > 0 && (
                        <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
                          <p className="text-sm font-medium text-green-800">
                            Transaction Amount: {selectedEscrowTicket?.currency || 'NGN'} {selectedEscrowTicket.transactionAmount.toLocaleString()}
                          </p>
                        </div>
                      )}

                      <p className="text-gray-600 text-sm">{selectedEscrowTicket?.description}</p>
                    </div>
                    
                    <button
                      onClick={() => handleDeleteEscrowTicket(selectedEscrowTicket._id)}
                      disabled={deletingEscrowTicketId === selectedEscrowTicket._id}
                      className={`text-red-600 hover:text-red-700 text-sm p-2 hover:bg-red-50 rounded-lg transition-colors ${deletingEscrowTicketId === selectedEscrowTicket._id ? 'opacity-50 cursor-not-allowed' : ''}`}
                      title="Permanently delete this escrow ticket"
                    >
                      {deletingEscrowTicketId === selectedEscrowTicket._id ? (
                        <RefreshCw className="w-5 h-5 animate-spin" />
                      ) : (
                        <Trash2 className="w-5 h-5" />
                      )}
                    </button>
                  </div>

                  {/* Messages */}
                  <div className="space-y-4 mb-6 max-h-96 overflow-y-auto">
                    {selectedEscrowTicket?.messages?.map((message, index) => (
                      <div
                        key={index}
                        className={`flex ${
                          message?.sender === 'admin' ? 'justify-center' :
                          message?.sender === 'initiator' ? 'justify-start' : 'justify-end'
                        }`}
                      >
                        <div
                          className={`max-w-xs lg:max-w-md px-4 py-3 rounded-lg ${
                            message?.sender === 'admin'
                              ? 'bg-red-100 text-red-900 border border-red-200'
                              : message?.sender === 'initiator'
                              ? 'bg-blue-100 text-blue-900'
                              : 'bg-green-100 text-green-900'
                          }`}
                        >
                          <p className="text-sm">{message?.message}</p>
                          <p className={`text-xs mt-1 ${
                            message?.sender === 'admin' ? 'text-red-600' :
                            message?.sender === 'initiator' ? 'text-blue-600' : 'text-green-600'
                          }`}>
                            {message?.sender === 'admin' ? 'Global Admin' :
                             message?.sender === 'initiator' ? 'Initiator' : 'Recipient'} • {' '}
                            {new Date(message?.timestamp).toLocaleString()}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Admin Reply Form */}
                  <form onSubmit={handleEscrowReply} className="border-t pt-4">
                    <div className="flex space-x-3">
                      <textarea
                        value={escrowReplyMessage}
                        onChange={(e) => setEscrowReplyMessage(e.target.value)}
                        placeholder="Send message as Global Admin..."
                        rows="3"
                        className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                        required
                      />
                      <LoadingButton
                        type="submit"
                        disabled={!escrowReplyMessage.trim()}
                        isLoading={escrowReplyLoading}
                        loadingText=""
                        size="sm"
                        title="Send reply message"
                      >
                        <Send className="w-4 h-4" />
                      </LoadingButton>
                    </div>
                  </form>
                </div>
              ) : (
                <div className="bg-white rounded-lg shadow-md p-6 text-center py-12">
                  <Shield className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">
                    Select an escrow ticket to view details
                  </h3>
                  <p className="text-gray-600">
                    Choose a ticket from the list to see the conversation and manage the transaction
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Advertisements Tab */}
        {activeTab === 'advertisements' && (
          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold text-gray-900">Advertisement Management</h2>
              <LoadingButton
                isLoading={false}
                onClick={() => setShowAdForm(true)}
                title="Create a new advertisement"
              >
                <Plus className="w-4 h-4" />
                Create Advertisement
              </LoadingButton>
            </div>

            {/* Search and Sort Controls */}
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label htmlFor="advertisementsSearch" className="block text-sm font-medium text-gray-700 mb-1">
                    Search Ads
                  </label>
                  <input
                    type="text"
                    id="advertisementsSearch"
                    value={advertisementsSearch}
                    onChange={(e) => setAdvertisementsSearch(e.target.value)}
                    placeholder="Name, description..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label htmlFor="advertisementsSortBy" className="block text-sm font-medium text-gray-700 mb-1">
                    Sort By
                  </label>
                  <select
                    id="advertisementsSortBy"
                    value={advertisementsSortBy}
                    onChange={(e) => setAdvertisementsSortBy(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="createdAt">Created Date</option>
                    <option value="name">Name</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="advertisementsSortOrder" className="block text-sm font-medium text-gray-700 mb-1">
                    Order
                  </label>
                  <select
                    id="advertisementsSortOrder"
                    value={advertisementsSortOrder}
                    onChange={(e) => setAdvertisementsSortOrder(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="desc">Newest First</option>
                    <option value="asc">Oldest First</option>
                  </select>
                </div>
              </div>
              <div className="flex justify-end mt-4">
                <LoadingButton
                  isLoading={false}
                  onClick={() => fetchAdvertisements(1, advertisementsPagination.pageSize)}
                  title="Apply search and sort filters"
                >
                  Apply Filters
                </LoadingButton>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {advertisements.map((ad) => (
                <div key={ad._id} className="bg-white rounded-lg shadow-md p-6">
                  <div className="mb-4">
                    {ad.mediaType === 'image' ? (
                      <img
                        src={ad.mediaUrl}
                        alt={ad.name}
                        className="w-full h-48 object-cover rounded-lg"
                      />
                    ) : (
                      <video
                        src={ad.mediaUrl}
                        className="w-full h-48 object-cover rounded-lg"
                        controls
                      />
                    )}
                  </div>
                  
                  <h3 className="font-semibold text-gray-900 mb-2">{ad.name}</h3>
                  <p className="text-gray-600 text-sm mb-3">{ad.description}</p>
                  
                  <div className="flex items-center justify-between mb-4">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                      ad.isActive 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {ad.isActive ? 'Active' : 'Inactive'}
                    </span>
                    <span className="text-xs text-gray-500">
                      {ad.duration}
                    </span>
                  </div>
                  
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleDeleteAd(ad._id)}
                      disabled={deletingAdId === ad._id}
                      className={`flex-1 text-red-600 hover:bg-red-50 py-2 px-3 rounded-lg text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center`}
                    >
                      {deletingAdId === ad._id ? (
                        <RefreshCw className="w-4 h-4 animate-spin" />
                      ) : (
                        'Delete'
                      )}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {advertisements.length > 0 && (
              <div className="mt-6 px-4 py-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                  <div className="text-sm text-gray-700">
                    Page {advertisementsPagination.currentPage} of {advertisementsPagination.totalPages} ({advertisementsPagination.total} ads)
                  </div>
                  <div className="flex flex-wrap items-center gap-2">
                    <label htmlFor="adPageSize" className="text-sm text-gray-600">Show:</label>
                    <select
                      id="adPageSize"
                      value={advertisementsPagination.pageSize}
                      onChange={(e) => {
                        const newSize = parseInt(e.target.value, 10)
                        setAdvertisementsPagination((prev) => ({ ...prev, pageSize: newSize }))
                        fetchAdvertisements(1, newSize)
                      }}
                      className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    {advertisementsPagination.totalPages > 1 && (
                      <>
                        <button
                          onClick={() => fetchAdvertisements(1, advertisementsPagination.pageSize)}
                          disabled={advertisementsPagination.currentPage <= 1}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          First
                        </button>
                        <button
                          onClick={() => fetchAdvertisements(advertisementsPagination.currentPage - 1, advertisementsPagination.pageSize)}
                          disabled={advertisementsPagination.currentPage <= 1}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Previous
                        </button>
                        <button
                          onClick={() => fetchAdvertisements(advertisementsPagination.currentPage + 1, advertisementsPagination.pageSize)}
                          disabled={advertisementsPagination.currentPage >= advertisementsPagination.totalPages}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                        <button
                          onClick={() => fetchAdvertisements(advertisementsPagination.totalPages, advertisementsPagination.pageSize)}
                          disabled={advertisementsPagination.currentPage >= advertisementsPagination.totalPages}
                          className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Last
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {advertisements.length === 0 && (
              <div className="bg-white rounded-lg shadow-md p-6 text-center py-12">
                <Upload className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  No advertisements yet
                </h3>
                <p className="text-gray-600">
                  Create your first advertisement to get started
                </p>
              </div>
            )}
          </div>
        )}

        {/* AdSense Management Tab - Original Global Admin only */}
        {activeTab === 'adsense' && currentAdmin?.isOriginal && (
          <div>
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6 gap-4">
              <div>
                <h2 className="text-xl font-semibold text-gray-900">AdSense Configuration</h2>
                <p className="text-sm text-gray-600">Centralized AdSense control for the Original Global Admin.</p>
              </div>
              <div className="space-y-3 sm:space-y-0 sm:flex sm:items-center sm:space-x-3">
                <button
                  onClick={() => fetchAdSenseConfig(adsensePagesPagination.currentPage, adsensePagesPagination.pageSize)}
                  disabled={adsenseLoading}
                  className={`bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center`}
                >
                  {adsenseLoading ? (
                    <>
                      <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                      Refreshing...
                    </>
                  ) : (
                    <>
                      <RefreshCw className="w-4 h-4 mr-2" />
                      Refresh Pages
                    </>
                  )}
                </button>
                <button
                  onClick={() => updateAdSenseConfig({ enabled: !adsenseConfig?.enabled })}
                  disabled={adsenseConfigLoading}
                  className={`px-4 py-2 rounded-lg text-white disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${adsenseConfig?.enabled ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'}`}
                >
                  {adsenseConfigLoading ? (
                    <>
                      <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                      Updating...
                    </>
                  ) : (
                    adsenseConfig?.enabled ? 'Disable AdSense' : 'Enable AdSense'
                  )}
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Global AdSense Settings</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Publisher ID</label>
                    <input
                      type="text"
                      value={adsenseConfig?.publisherId || ''}
                      onChange={(e) => {
                        setAdSenseConfig((prev) => ({ ...prev, publisherId: e.target.value }))
                        // Clear error when user starts typing
                        if (adsenseValidationErrors.publisherId) {
                          setAdSenseValidationErrors(prev => ({ ...prev, publisherId: null }))
                        }
                      }}
                      className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        adsenseValidationErrors.publisherId ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="pub-xxxxxxxxxxxxxxxx"
                    />
                    {adsenseValidationErrors.publisherId && (
                      <p className="mt-1 text-sm text-red-600">{adsenseValidationErrors.publisherId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Ad Client ID</label>
                    <input
                      type="text"
                      value={adsenseConfig?.adClientId || ''}
                      onChange={(e) => {
                        setAdSenseConfig((prev) => ({ ...prev, adClientId: e.target.value }))
                        // Clear error when user starts typing
                        if (adsenseValidationErrors.adClientId) {
                          setAdSenseValidationErrors(prev => ({ ...prev, adClientId: null }))
                        }
                      }}
                      className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        adsenseValidationErrors.adClientId ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="ca-pub-xxxxxxxxxxxxxxxx"
                    />
                    {adsenseValidationErrors.adClientId && (
                      <p className="mt-1 text-sm text-red-600">{adsenseValidationErrors.adClientId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">AdSense Script</label>
                    <textarea
                      rows="4"
                      value={adsenseConfig?.adScript || ''}
                      onChange={(e) => {
                        setAdSenseConfig((prev) => ({ ...prev, adScript: e.target.value }))
                        // Clear error when user starts typing
                        if (adsenseValidationErrors.adScript) {
                          setAdSenseValidationErrors(prev => ({ ...prev, adScript: null }))
                        }
                      }}
                      className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        adsenseValidationErrors.adScript ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Paste your AdSense script here"
                    />
                    {adsenseValidationErrors.adScript && (
                      <p className="mt-1 text-sm text-red-600">{adsenseValidationErrors.adScript}</p>
                    )}
                  </div>

                  <div className="flex items-center justify-between gap-4">
                    <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                      <input
                        type="checkbox"
                        checked={adsenseConfig?.autoAdsEnabled || false}
                        onChange={(e) => setAdSenseConfig((prev) => ({ ...prev, autoAdsEnabled: e.target.checked }))}
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                      />
                      Enable Auto Ads
                    </label>
                    <button
                      type="button"
                      onClick={() => {
                        if (validateAdSenseConfig()) {
                          updateAdSenseConfig({
                            enabled: adsenseConfig?.enabled,
                            autoAdsEnabled: adsenseConfig?.autoAdsEnabled,
                            publisherId: adsenseConfig?.publisherId,
                            adClientId: adsenseConfig?.adClientId,
                            adScript: adsenseConfig?.adScript,
                            adSlots: adsenseConfig?.adSlots || []
                          })
                        } else {
                          setAdSenseSaveAttempted(true)
                          toast.error('Please fix the validation errors before saving')
                        }
                      }}
                      disabled={adsenseConfigLoading}
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {adsenseConfigLoading ? (
                        <>
                          <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                          Saving...
                        </>
                      ) : (
                        'Save Settings'
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Page-Level Approval</h3>
                <p className="text-sm text-gray-600 mb-4">Only pages explicitly approved here will render AdSense ads.</p>

                {adsenseLoading ? (
                  <div className="text-sm text-gray-500">Loading eligible pages...</div>
                ) : (
                  <div className="space-y-3">
                    {adsensePages.length > 0 ? (
                      adsensePages.map((page) => (
                        <div key={page.pageId} className="border border-gray-200 rounded-lg p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                          <div>
                            <p className="text-sm font-semibold text-gray-900">{page.label}</p>
                            <p className="text-xs text-gray-500">Path: {page.path}</p>
                            <p className="text-xs text-gray-500">Source: {page.source}</p>
                          </div>
                          <button
                            onClick={() => toggleAdSensePageApproval(page.pageId, !page.approved)}
                            disabled={adsensePageLoading[page.pageId]}
                            className={`px-4 py-2 rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${page.approved ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-green-600 text-white hover:bg-green-700'}`}
                          >
                            {adsensePageLoading[page.pageId] ? (
                              <>
                                <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                                Updating...
                              </>
                            ) : (
                              page.approved ? 'Disable Ads' : 'Enable Ads'
                            )}
                          </button>
                        </div>
                      ))
                    ) : (
                      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
                        <p className="text-gray-600">No eligible AdSense pages detected yet.</p>
                        <p className="text-sm text-gray-500">Published websites without a custom domain and verified public pages will appear here.</p>
                      </div>
                    )}
                  </div>
                )}

                {adsensePages.length > 0 && (
                  <div className="mt-6 px-4 py-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                      <div className="text-sm text-gray-700">
                        Page {adsensePagesPagination.currentPage} of {adsensePagesPagination.totalPages} ({adsensePagesPagination.total} pages)
                      </div>
                      <div className="flex flex-wrap items-center gap-2">
                        <label htmlFor="adsensePageSize" className="text-sm text-gray-600">Show:</label>
                        <select
                          id="adsensePageSize"
                          value={adsensePagesPagination.pageSize}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10)
                            setAdSensePagesPagination((prev) => ({ ...prev, pageSize: newSize }))
                            fetchAdSenseConfig(1, newSize)
                          }}
                          className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                        {adsensePagesPagination.totalPages > 1 && (
                          <>
                            <button
                              onClick={() => fetchAdSenseConfig(1, adsensePagesPagination.pageSize)}
                              disabled={adsensePagesPagination.currentPage <= 1}
                              className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              First
                            </button>
                            <button
                              onClick={() => fetchAdSenseConfig(adsensePagesPagination.currentPage - 1, adsensePagesPagination.pageSize)}
                              disabled={adsensePagesPagination.currentPage <= 1}
                              className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              Previous
                            </button>
                            <button
                              onClick={() => fetchAdSenseConfig(adsensePagesPagination.currentPage + 1, adsensePagesPagination.pageSize)}
                              disabled={adsensePagesPagination.currentPage >= adsensePagesPagination.totalPages}
                              className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              Next
                            </button>
                            <button
                              onClick={() => fetchAdSenseConfig(adsensePagesPagination.totalPages, adsensePagesPagination.pageSize)}
                              disabled={adsensePagesPagination.currentPage >= adsensePagesPagination.totalPages}
                              className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              Last
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Create Global Admin Modal */}
      {showCreateAdminModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl max-w-md w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Create Global Admin
            </h3>
            
            <form onSubmit={handleCreateAdmin} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  required
                  value={newAdminData.email}
                  onChange={(e) => setNewAdminData(prev => ({ ...prev, email: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter admin email"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Password *
                </label>
                <input
                  type="password"
                  required
                  minLength="6"
                  value={newAdminData.password}
                  onChange={(e) => setNewAdminData(prev => ({ ...prev, password: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter admin password"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Password must be at least 6 characters long
                </p>
              </div>
              
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                <p className="text-sm text-yellow-800">
                  <strong>Note:</strong> Created admins will have full platform access except:
                </p>
                <ul className="text-sm text-yellow-700 mt-1 ml-4 list-disc">
                  <li>Cannot delete support tickets</li>
                  <li>Cannot manage other global admins</li>
                  <li>Cannot modify the original admin account</li>
                </ul>
              </div>
              
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowCreateAdminModal(false)}
                  className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <LoadingButton
                  type="submit"
                  isLoading={createAdminLoading}
                  loadingText="Creating..."
                  className="flex-1"
                  title="Create new global admin account"
                >
                  Create Admin
                </LoadingButton>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Create Advertisement Modal */}
      {showAdForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl max-w-md w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Create Advertisement
            </h3>
            
            <form onSubmit={handleCreateAd} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Advertisement Name *
                </label>
                <input
                  type="text"
                  required
                  value={adFormData.name}
                  onChange={(e) => setAdFormData(prev => ({ ...prev, name: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter advertisement name"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description *
                </label>
                <textarea
                  required
                  value={adFormData.description}
                  onChange={(e) => setAdFormData(prev => ({ ...prev, description: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  rows="3"
                  placeholder="Enter advertisement description"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Duration *
                </label>
                <select
                  value={adFormData.duration}
                  onChange={(e) => setAdFormData(prev => ({ ...prev, duration: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="day">1 Day</option>
                  <option value="week">1 Week</option>
                  <option value="month">1 Month</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Upload Media
                </label>
                <input
                  type="file"
                  accept="image/*,video/*"
                  onChange={(e) => setAdFile(e.target.files[0])}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Or Media URL
                </label>
                <input
                  type="url"
                  value={adFormData.mediaUrl}
                  onChange={(e) => setAdFormData(prev => ({ ...prev, mediaUrl: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="https://example.com/image.jpg"
                />
              </div>
              
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowAdForm(false)}
                  className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <LoadingButton
                  type="submit"
                  isLoading={creatingAd}
                  loadingText="Creating..."
                  className="flex-1"
                  title="Create new advertisement"
                >
                  Create Advertisement
                </LoadingButton>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Send Message Modal */}
      {showMessageModal && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl max-w-md w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Send Message to {getUserDisplayName(selectedUser)}
            </h3>
            
            <form onSubmit={handleSendMessage} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Subject *
                </label>
                <input
                  type="text"
                  required
                  value={messageData.subject}
                  onChange={(e) => setMessageData(prev => ({ ...prev, subject: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter message subject"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Message *
                </label>
                <textarea
                  required
                  value={messageData.message}
                  onChange={(e) => setMessageData(prev => ({ ...prev, message: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  rows="4"
                  placeholder="Enter your message"
                />
              </div>
              
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowMessageModal(false)}
                  className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <LoadingButton
                  type="submit"
                  isLoading={sendMessageLoading}
                  loadingText="Sending..."
                  className="flex-1"
                  title="Send message to user"
                >
                  Send Message
                </LoadingButton>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Broadcast Message Modal */}
      {showBroadcastModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl max-w-md w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Broadcast Message to All Users
            </h3>
            
            <form onSubmit={handleBroadcastMessage} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Subject *
                </label>
                <input
                  type="text"
                  required
                  value={broadcastData.subject}
                  onChange={(e) => setBroadcastData(prev => ({ ...prev, subject: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter broadcast subject"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Message *
                </label>
                <textarea
                  required
                  value={broadcastData.message}
                  onChange={(e) => setBroadcastData(prev => ({ ...prev, message: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  rows="4"
                  placeholder="Enter your broadcast message"
                />
              </div>
              
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                <p className="text-sm text-yellow-800">
                  This message will be sent to all active users on the platform.
                </p>
              </div>
              
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowBroadcastModal(false)}
                  className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <LoadingButton
                  type="submit"
                  isLoading={broadcastLoading}
                  loadingText="Sending..."
                  className="flex-1"
                  title="Send broadcast message to all users"
                >
                  Send Broadcast
                </LoadingButton>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>

    <footer className="bg-gray-800 border-t border-gray-700 mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <p className="text-center text-gray-400 text-xs">© 2026 Marketbook Solution. All rights reserved.</p>
      </div>
    </footer>
  </>
)
}